import { a as getArrayRemovePatches, c as useOptimisticActorReady, i as getArrayMovePatches, l as get, n as getArrayInsertPatches, o as useDocuments, r as getArrayItemKeyAndParentPath, s as useOptimisticActor, t as getArrayDuplicatePatches } from "./mutations-D78SQhfO.js";
import { t as createDatasetMutator } from "./datasetMutator-ZJwbpFTy.js";
import { a as setActor } from "./context-ChQ0Q6hG.js";
import { a as testVercelStegaRegex, i as stegaClean, n as createOverlayController, o as v4, r as sanityNodesExistInSameArray, t as SharedStateContext } from "./SharedStateContext-DPUAUle3.js";
import { a as TelemetryContext, c as PopoverPortal, i as useTelemetry, l as getNodeIcon, n as InsertMenu, o as events, s as PopoverBackground, t as PointerEvents } from "./PointerEvents-DYXUIXGG.js";
import { c } from "react/compiler-runtime";
import { createEditUrl, getDraftId, getPublishedId, studioPath } from "@sanity/client/csm";
import { at, insert, remove } from "@sanity/mutate";
import { createCompatibilityActors, isMaybePreviewIframe, isMaybePreviewWindow } from "@sanity/presentation-comlink";
import { Fragment, Suspense, createContext, isValidElement, lazy, memo, startTransition, useContext, useDeferredValue, useEffect, useEffectEvent, useId, useReducer, useRef, useState, useSyncExternalStore } from "react";
import { createActor } from "xstate";
import "@sanity/client";
import { decodeSanityNodeData, pathToUrlString } from "@sanity/visual-editing-csm";
import { vercelStegaDecode } from "@vercel/stega";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { createPortal } from "react-dom";
import "@sanity/ui/styles.css";
import { Box, Button, Card, Flex, Hotkeys, LayerProvider, PortalProvider, Spinner, Stack, Text, ThemeProvider, isHTMLAnchorElement, isHTMLElement, studioTheme, usePrefersDark, useTheme_v2 } from "@sanity/ui";
import { css, styled } from "styled-components";
import { Menu, MenuButton, MenuDivider, MenuGroup, MenuItem } from "@sanity/ui/menu";
import { Popover } from "@sanity/ui/popover";
import { ReplaySubject, Subject, merge } from "rxjs";
import { ArrowDownIcon } from "@sanity/icons/ArrowDown";
import { ArrowUpIcon } from "@sanity/icons/ArrowUp";
import { CopyIcon } from "@sanity/icons/Copy";
import { InsertAboveIcon } from "@sanity/icons/InsertAbove";
import { InsertBelowIcon } from "@sanity/icons/InsertBelow";
import { PublishIcon } from "@sanity/icons/Publish";
import { RemoveIcon } from "@sanity/icons/Remove";
import { SortIcon } from "@sanity/icons/Sort";
import { UnpublishIcon } from "@sanity/icons/Unpublish";
import { DocumentIcon } from "@sanity/icons/Document";
import { DragHandleIcon } from "@sanity/icons/DragHandle";
import { EllipsisVerticalIcon } from "@sanity/icons/EllipsisVertical";
import { PlugIcon } from "@sanity/icons/Plug";
import scrollIntoView from "scroll-into-view-if-needed";
import { ExpandIcon } from "@sanity/icons/Expand";
import { createNode, createNodeMachine } from "@sanity/comlink";
function isTextField(element) {
	return element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement;
}
function getTextFieldSelection(element) {
	try {
		let { selectionStart, selectionEnd, value } = element;
		return selectionStart === null || selectionEnd === null || selectionStart === selectionEnd ? null : value.slice(selectionStart, selectionEnd);
	} catch {
		return null;
	}
}
function serializeRangesToHtml(selection) {
	let html = "";
	for (let i = 0; i < selection.rangeCount; i++) {
		let container = document.createElement("div");
		container.appendChild(selection.getRangeAt(i).cloneContents()), html += container.innerHTML;
	}
	return html;
}
/**
* Handles a `copy` event by rewriting the clipboard payload without stega-encoded metadata.
* If the copied content doesn't contain any stega characters the event is left untouched and
* the default browser behavior applies.
* @internal
*/
function cleanStegaFromCopyEvent(event) {
	if (event.defaultPrevented) return;
	let { clipboardData } = event;
	if (!clipboardData) return;
	let activeElement = document.activeElement;
	if (isTextField(activeElement)) {
		let text = getTextFieldSelection(activeElement);
		if (!text || !testVercelStegaRegex(text)) return;
		event.preventDefault(), clipboardData.setData("text/plain", stegaClean(text));
		return;
	}
	let selection = document.getSelection();
	if (!selection || selection.isCollapsed || selection.rangeCount === 0) return;
	let text = selection.toString(), html = serializeRangesToHtml(selection);
	!testVercelStegaRegex(text) && !testVercelStegaRegex(html) || (event.preventDefault(), clipboardData.setData("text/plain", stegaClean(text)), html && clipboardData.setData("text/html", stegaClean(html)));
}
/**
* Strips stega-encoded metadata (invisible characters) from clipboard data when content is
* copied from the page, so copied text can be pasted into other tools without the hidden
* characters tagging along. Copies that don't contain stega are left untouched.
* @returns A function that disables the behavior again
* @internal
*/
function enableStegaCleanOnCopy() {
	return document.addEventListener("copy", cleanStegaFromCopyEvent), () => {
		document.removeEventListener("copy", cleanStegaFromCopyEvent);
	};
}
const EXPECTED_STEGA_ATTRIBUTES = {
	IMG: ["alt"],
	TIME: ["datetime"],
	SVG: ["aria-label"]
};
function isElement(node) {
	return node.nodeType === Node.ELEMENT_NODE;
}
function isOverlayElement(node) {
	return isElement(node) && node.tagName.toUpperCase() === "SANITY-VISUAL-EDITING";
}
function isInsideOverlay(node) {
	let element = isElement(node) ? node : node.parentElement;
	return element ? element.closest("sanity-visual-editing") !== null : !1;
}
function isInsideHead(node) {
	return document.head ? document.head.contains(node) : !1;
}
function isExpectedStegaAttribute(element, attributeName) {
	return EXPECTED_STEGA_ATTRIBUTES[element.tagName.toUpperCase()]?.includes(attributeName.toLowerCase()) ?? !1;
}
function checkAttribute(element, attributeName, value, inHead, sink) {
	if (!(!value || !testVercelStegaRegex(value))) {
		if (inHead) {
			sink("head", element, attributeName, value);
			return;
		}
		isExpectedStegaAttribute(element, attributeName) || sink("attribute", element, attributeName, value);
	}
}
function checkElementAttributes(element, inHead, sink) {
	let { attributes } = element;
	for (let i = 0; i < attributes.length; i++) {
		let attribute = attributes[i];
		attribute && checkAttribute(element, attribute.name, attribute.value, inHead, sink);
	}
}
function checkTextNode(node, inHead, sink) {
	let parentElement = node.parentElement, kind;
	if (inHead) kind = "head";
	else {
		if (!parentElement) return;
		switch (parentElement.tagName.toUpperCase()) {
			case "SCRIPT":
				kind = "script";
				break;
			case "STYLE":
				kind = "style";
				break;
			case "TEXTAREA":
				kind = "form-value";
				break;
			default: return;
		}
	}
	let value = node.textContent;
	!value || !testVercelStegaRegex(value) || sink(kind, parentElement ?? void 0, void 0, value);
}
function visitNode(node, inHead, sink) {
	if (isElement(node)) {
		if (isOverlayElement(node)) return;
		checkElementAttributes(node, inHead, sink);
	} else node.nodeType === Node.TEXT_NODE && checkTextNode(node, inHead, sink);
}
function auditTree(root, inHead, sink) {
	visitNode(root, inHead, sink);
	let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, { acceptNode: (node) => isOverlayElement(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT }), node;
	for (; node = walker.nextNode();) visitNode(node, inHead, sink);
}
function checkLocation(sink) {
	let href = location.href;
	if (testVercelStegaRegex(href)) {
		sink("url", void 0, void 0, href);
		return;
	}
	try {
		let decoded = decodeURIComponent(href);
		testVercelStegaRegex(decoded) && sink("url", void 0, void 0, decoded);
	} catch {}
}
function auditDocument(sink) {
	let { documentElement, head, body } = document;
	documentElement && checkElementAttributes(documentElement, !1, sink), head && auditTree(head, !0, sink), body && auditTree(body, !1, sink), checkLocation(sink);
}
function processMutation(mutation, sink) {
	let { target, type } = mutation;
	if (!(!target.isConnected || isInsideOverlay(target))) {
		if (type === "attributes") {
			if (isElement(target) && mutation.attributeName) {
				let value = target.getAttributeNS(mutation.attributeNamespace, mutation.attributeName);
				checkAttribute(target, mutation.attributeName, value, isInsideHead(target), sink);
			}
		} else if (type === "characterData") checkTextNode(target, isInsideHead(target), sink);
		else for (let i = 0; i < mutation.addedNodes.length; i++) {
			let added = mutation.addedNodes[i];
			!added || !added.isConnected || isInsideOverlay(added) || auditTree(added, isInsideHead(added), sink);
		}
	}
}
function decodeSanity(value) {
	try {
		let decoded = vercelStegaDecode(value);
		return !decoded || typeof decoded != "object" || decoded.origin !== "sanity.io" ? void 0 : decodeSanityNodeData(decoded) ?? decoded;
	} catch {
		return;
	}
}
function scheduleIdle(callback) {
	if (typeof requestIdleCallback == "function") {
		let id = requestIdleCallback(callback, { timeout: 1e3 });
		return () => cancelIdleCallback(id);
	}
	let id = setTimeout(callback, 0);
	return () => clearTimeout(id);
}
/**
* Scans the document for stega payloads in places where they always cause bugs or bloat
* (attributes, `<head>`, `<script>` and `<style>` contents, form values and the page URL) and
* reports findings to the given callback.
*
* Performs an initial full audit and then watches for DOM changes, only re-checking what
* actually changed. All work is deferred to idle time, reports are deduped and batched.
* @returns A function that stops the scanning
* @internal
*/
function observeSuspiciousStega(onSuspiciousStega) {
	let reported = /* @__PURE__ */ new Set(), pendingReports = [], pendingMutations = [], initialAuditDone = !1, cancelScheduled = null, disposed = !1, sink = (kind, element, attribute, value) => {
		let cleaned = stegaClean(value), key = `${kind}|${attribute ?? ""}|${cleaned}`;
		reported.has(key) || (reported.add(key), pendingReports.push({
			kind,
			element,
			attribute,
			value,
			cleaned,
			sanity: decodeSanity(value)
		}));
	}, process = () => {
		if (cancelScheduled = null, !disposed) {
			if (initialAuditDone || (initialAuditDone = !0, auditDocument(sink)), pendingMutations.length > 0) {
				let mutations = pendingMutations.splice(0);
				for (let mutation of mutations) processMutation(mutation, sink);
			}
			pendingReports.length > 0 && onSuspiciousStega(pendingReports.splice(0));
		}
	}, schedule = () => {
		cancelScheduled || disposed || (cancelScheduled = scheduleIdle(process));
	}, observer = new MutationObserver((mutations) => {
		for (let mutation of mutations) pendingMutations.push(mutation);
		schedule();
	});
	return observer.observe(document.documentElement, {
		attributes: !0,
		characterData: !0,
		childList: !0,
		subtree: !0
	}), schedule(), () => {
		disposed = !0, observer.disconnect(), cancelScheduled?.(), cancelScheduled = null;
	};
}
const listeners = /* @__PURE__ */ new Set();
function subscribe$1(listener) {
	return listeners.add(listener), () => void listeners.delete(listener);
}
let environment = null;
function getSnapshot() {
	return environment;
}
function setEnvironment(nextEnvironment) {
	if (environment !== nextEnvironment) {
		environment = nextEnvironment;
		for (let onEnvironmentChange of listeners) onEnvironmentChange();
	}
}
/**
* @internal
*/
const History = (props) => {
	let $ = c(8), { comlink, history } = props, t0, t1;
	$[0] !== comlink || $[1] !== history ? (t0 = () => comlink?.on("presentation/navigate", (data) => {
		history?.update(data);
	}), t1 = [comlink, history], $[0] = comlink, $[1] = history, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1);
	let t2, t3;
	return $[4] !== comlink || $[5] !== history ? (t2 = () => {
		if (history) return history.subscribe((update) => {
			update.title = update.title || document.title, comlink?.post("visual-editing/navigate", update);
		});
	}, t3 = [comlink, history], $[4] = comlink, $[5] = history, $[6] = t2, $[7] = t3) : (t2 = $[6], t3 = $[7]), useEffect(t2, t3), null;
}, comlinkListeners = /* @__PURE__ */ new Set();
/** @internal */
let comlink = null, comlinkProjectId = null, comlinkDataset = null, comlinkPerspective = null, comlinkVariant = null;
/** @internal */
function setLoaderComlink(nextComlink) {
	comlink = nextComlink;
	for (let listener of comlinkListeners) listener();
}
/** @internal */
function setLoaderClientConfig(projectId, dataset) {
	comlinkProjectId = projectId, comlinkDataset = dataset;
	for (let listener of comlinkListeners) listener();
}
/** @internal */
function setLoaderPerspective(perspective) {
	comlinkPerspective = perspective;
	for (let listener of comlinkListeners) listener();
}
/** @internal */
function setLoaderVariant(variant) {
	comlinkVariant = variant;
	for (let listener of comlinkListeners) listener();
}
/** @internal */
function subscribe(listener) {
	return comlinkListeners.add(listener), () => comlinkListeners.delete(listener);
}
/**
* Tracks whether there are any active `usePresentationQuery` consumers.
* `LoaderComlink` is only mounted when `hasQueryListeners` is true.
*/
const queryListenerStatusListeners = /* @__PURE__ */ new Set();
let hasQueryListeners = !1, queryListenerCount = 0;
/** @internal */
function subscribeQueryListenerStatus(listener) {
	return queryListenerStatusListeners.add(listener), () => queryListenerStatusListeners.delete(listener);
}
/** @internal */
function getQueryListenerStatus() {
	return hasQueryListeners;
}
/** @internal */
function addQueryListener() {
	if (queryListenerCount++, !hasQueryListeners) {
		hasQueryListeners = !0;
		for (let listener of queryListenerStatusListeners) listener();
	}
	return () => {
		if (queryListenerCount--, queryListenerCount === 0 && hasQueryListeners) {
			hasQueryListeners = !1;
			for (let listener of queryListenerStatusListeners) listener();
		}
	};
}
/**
* @internal
*/
const Meta = (props) => {
	let $ = c(3), { comlink } = props, t0, t1;
	return $[0] === comlink ? (t0 = $[1], t1 = $[2]) : (t0 = () => {
		let sendMeta = () => {
			comlink.post("visual-editing/meta", { title: document.title });
		}, observer = new MutationObserver((t2) => {
			let [mutation] = t2;
			mutation.target.nodeName === "TITLE" && sendMeta();
		});
		return observer.observe(document.head, {
			subtree: !0,
			characterData: !0,
			childList: !0
		}), sendMeta(), () => observer.disconnect();
	}, t1 = [comlink], $[0] = comlink, $[1] = t0, $[2] = t1), useEffect(t0, t1), null;
};
function getReferenceNodeAndInsertPosition(position) {
	if (position) {
		let { top, right, bottom, left } = position;
		if (left || top) return {
			node: (left ?? top).sanity,
			position: "after"
		};
		if (right || bottom) return {
			node: (right ?? bottom).sanity,
			position: "before"
		};
	}
}
function useDragEndEvents() {
	let $ = c(4), { getDocument } = useDocuments(), t0, t1;
	$[0] === getDocument ? (t0 = $[1], t1 = $[2]) : (t0 = () => {
		let handler = (e) => {
			let { insertPosition, target, preventInsertDefault } = e.detail;
			if (preventInsertDefault) return;
			let reference = getReferenceNodeAndInsertPosition(insertPosition);
			if (reference) {
				let doc = getDocument(target.id), { node, position } = reference, { key: targetKey, hasExplicitKey } = getArrayItemKeyAndParentPath(target), { path: arrayPath, key: referenceItemKey } = getArrayItemKeyAndParentPath(node);
				arrayPath && referenceItemKey && referenceItemKey !== targetKey && doc.patch(async (t2) => {
					let { getSnapshot } = t2, snapshot = await getSnapshot(), elementValue = get(snapshot, target.path);
					return hasExplicitKey ? [at(arrayPath, remove({ _key: targetKey })), at(arrayPath, insert(elementValue, position, { _key: referenceItemKey }))] : [at(arrayPath, remove(~~targetKey)), at(arrayPath, insert(elementValue, position, referenceItemKey > targetKey ? ~~referenceItemKey - 1 : ~~referenceItemKey))];
				});
			}
		};
		return window.addEventListener("sanity/dragEnd", handler), () => {
			window.removeEventListener("sanity/dragEnd", handler);
		};
	}, t1 = [getDocument], $[0] = getDocument, $[1] = t0, $[2] = t1), useEffect(t0, t1);
	let dispatchDragEndEvent = _temp$10, t2;
	return $[3] === Symbol.for("react.memo_cache_sentinel") ? (t2 = { dispatchDragEndEvent }, $[3] = t2) : t2 = $[3], t2;
}
function _temp$10(event) {
	let customEvent = new CustomEvent("sanity/dragEnd", {
		detail: event,
		cancelable: !0
	});
	window.dispatchEvent(customEvent);
}
const SchemaContext = createContext(null);
function useSchema() {
	let context = useContext(SchemaContext);
	if (!context) throw Error("Schema context is missing");
	return context;
}
function getArrayRemoveAction(node, doc) {
	if (!node.type) throw Error("Node type is missing");
	return () => doc.patch(async ({ getSnapshot }) => getArrayRemovePatches(node, await getSnapshot()));
}
function getArrayInsertAction(node, doc, insertType, position) {
	if (!node.type) throw Error("Node type is missing");
	return () => doc.patch(() => getArrayInsertPatches(node, insertType, position));
}
function getDuplicateAction(node, doc) {
	if (!node.type) throw Error("Node type is missing");
	return () => doc.patch(async ({ getSnapshot }) => getArrayDuplicatePatches(node, await getSnapshot()));
}
function getContextMenuItems(context) {
	let { node, field, parent, doc } = context;
	return field?.type === "arrayItem" ? getContextMenuArrayItems({
		node,
		field,
		doc
	}) : parent?.type === "union" ? getContextMenuUnionItems({
		node,
		parent,
		doc
	}) : Promise.resolve([]);
}
function getDuplicateItem(context) {
	let { node, doc } = context;
	return doc ? [{
		type: "action",
		label: "Duplicate",
		icon: CopyIcon,
		action: getDuplicateAction(node, doc),
		telemetryEvent: "Visual Editing Context Menu Item Duplicated"
	}] : [];
}
function getRemoveItems(context) {
	let { node, doc } = context;
	return doc ? [{
		type: "action",
		label: "Remove",
		icon: RemoveIcon,
		action: getArrayRemoveAction(node, doc),
		telemetryEvent: "Visual Editing Context Menu Item Removed"
	}] : [];
}
async function getMoveItems(context, withDivider = !0) {
	let { node, doc } = context;
	if (!doc) return [];
	let items = [], groupItems = [], [moveUpPatches, moveDownPatches, moveFirstPatches, moveLastPatches] = await Promise.all([
		getArrayMovePatches(node, doc, "previous"),
		getArrayMovePatches(node, doc, "next"),
		getArrayMovePatches(node, doc, "first"),
		getArrayMovePatches(node, doc, "last")
	]);
	return moveFirstPatches.length && groupItems.push({
		type: "action",
		label: "To top",
		icon: PublishIcon,
		action: () => doc.patch(moveFirstPatches),
		telemetryEvent: "Visual Editing Context Menu Item Moved"
	}), moveUpPatches.length && groupItems.push({
		type: "action",
		label: "Up",
		icon: ArrowUpIcon,
		action: () => doc.patch(moveUpPatches),
		telemetryEvent: "Visual Editing Context Menu Item Moved"
	}), moveDownPatches.length && groupItems.push({
		type: "action",
		label: "Down",
		icon: ArrowDownIcon,
		action: () => doc.patch(moveDownPatches),
		telemetryEvent: "Visual Editing Context Menu Item Moved"
	}), moveLastPatches.length && groupItems.push({
		type: "action",
		label: "To bottom",
		icon: UnpublishIcon,
		action: () => doc.patch(moveLastPatches),
		telemetryEvent: "Visual Editing Context Menu Item Moved"
	}), groupItems.length && (items.push({
		type: "group",
		label: "Move",
		icon: SortIcon,
		items: groupItems
	}), withDivider && items.push({ type: "divider" })), items;
}
async function getContextMenuArrayItems(context) {
	let { node, field, doc } = context, items = [];
	return items.push(...getDuplicateItem(context)), items.push(...getRemoveItems(context)), items.push(...await getMoveItems(context)), items.push({
		type: "action",
		label: "Insert before",
		icon: InsertAboveIcon,
		action: getArrayInsertAction(node, doc, field.name, "before"),
		telemetryEvent: "Visual Editing Context Menu Item Inserted"
	}), items.push({
		type: "action",
		label: "Insert after",
		icon: InsertBelowIcon,
		action: getArrayInsertAction(node, doc, field.name, "after"),
		telemetryEvent: "Visual Editing Context Menu Item Inserted"
	}), items;
}
const InsertMenuWrapper = (props) => {
	let $ = c(12), { label, parent, width, onSelect, boundaryElement } = props, t0;
	$[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [
		"left-start",
		"right",
		"left",
		"right-end",
		"left-end",
		"bottom",
		"top"
	], $[0] = t0) : t0 = $[0];
	let t1;
	$[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = [
		4,
		4,
		4,
		4
	], $[1] = t1) : t1 = $[1];
	let t2;
	$[2] !== boundaryElement || $[3] !== width ? (t2 = {
		arrow: !1,
		constrainSize: !0,
		floatingBoundary: boundaryElement,
		padding: 0,
		placement: "right-start",
		fallbackPlacements: t0,
		preventOverflow: !0,
		width,
		__unstable_margins: t1
	}, $[2] = boundaryElement, $[3] = width, $[4] = t2) : t2 = $[4];
	let t3;
	$[5] !== onSelect || $[6] !== parent ? (t3 = /* @__PURE__ */ jsx(InsertMenu, {
		node: parent,
		onSelect
	}), $[5] = onSelect, $[6] = parent, $[7] = t3) : t3 = $[7];
	let t4;
	return $[8] !== label || $[9] !== t2 || $[10] !== t3 ? (t4 = /* @__PURE__ */ jsx(MenuGroup, {
		fontSize: 1,
		icon: InsertBelowIcon,
		padding: 2,
		popover: t2,
		gap: 2,
		text: label,
		children: t3
	}), $[8] = label, $[9] = t2, $[10] = t3, $[11] = t4) : t4 = $[11], t4;
};
async function getContextMenuUnionItems(context) {
	let { doc, node, parent } = context, items = [];
	if (items.push(...getDuplicateItem(context)), items.push(...getRemoveItems(context)), items.push(...await getMoveItems(context)), parent.options?.insertMenu) {
		let width = (parent.options.insertMenu || {}).views?.some((view) => view.name === "grid") ? 0 : void 0;
		items.push({
			type: "custom",
			component: ({ boundaryElement, sendTelemetry }) => {
				let onSelect = (schemaType) => {
					getArrayInsertAction(node, doc, schemaType.name, "before")(), sendTelemetry("Visual Editing Context Menu Item Inserted", null);
				};
				return /* @__PURE__ */ jsx(InsertMenuWrapper, {
					label: "Insert before",
					onSelect,
					parent,
					width,
					boundaryElement
				});
			}
		}), items.push({
			type: "custom",
			component: ({ boundaryElement, sendTelemetry }) => {
				let onSelect = (schemaType) => {
					getArrayInsertAction(node, doc, schemaType.name, "after")(), sendTelemetry("Visual Editing Context Menu Item Inserted", null);
				};
				return /* @__PURE__ */ jsx(InsertMenuWrapper, {
					label: "Insert after",
					onSelect,
					parent,
					width,
					boundaryElement
				});
			}
		});
	} else items.push({
		type: "group",
		label: "Insert before",
		icon: InsertAboveIcon,
		items: parent.of.filter((item) => item.type === "unionOption").map((t) => ({
			type: "action",
			icon: getNodeIcon(t),
			label: t.name === "block" ? "Paragraph" : t.title || t.name,
			action: getArrayInsertAction(node, doc, t.name, "before"),
			telemetryEvent: "Visual Editing Context Menu Item Inserted"
		}))
	}), items.push({
		type: "group",
		label: "Insert after",
		icon: InsertBelowIcon,
		items: parent.of.filter((item) => item.type === "unionOption").map((t) => ({
			type: "action",
			label: t.name === "block" ? "Paragraph" : t.title || t.name,
			icon: getNodeIcon(t),
			action: getArrayInsertAction(node, doc, t.name, "after"),
			telemetryEvent: "Visual Editing Context Menu Item Inserted"
		}))
	});
	return items;
}
const POPOVER_MARGINS = [
	-4,
	4,
	-4,
	4
];
function ContextMenuItem(props) {
	let $ = c(27), { node, onDismiss, boundaryElement } = props, sendTelemetry = useTelemetry(), t0;
	$[0] !== node || $[1] !== onDismiss || $[2] !== sendTelemetry ? (t0 = () => {
		node.type === "action" && (node.action?.(), onDismiss?.(), node.telemetryEvent && sendTelemetry(node.telemetryEvent, null));
	}, $[0] = node, $[1] = onDismiss, $[2] = sendTelemetry, $[3] = t0) : t0 = $[3];
	let onClick = t0;
	if (node.type === "divider") {
		let t1;
		return $[4] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(MenuDivider, {}), $[4] = t1) : t1 = $[4], t1;
	}
	if (node.type === "action") {
		let t1 = !node.action, t2;
		return $[5] !== node.hotkeys || $[6] !== node.icon || $[7] !== node.label || $[8] !== onClick || $[9] !== t1 ? (t2 = /* @__PURE__ */ jsx(MenuItem, {
			fontSize: 1,
			hotkeys: node.hotkeys,
			icon: node.icon,
			padding: 2,
			gap: 2,
			text: node.label,
			disabled: t1,
			onClick
		}), $[5] = node.hotkeys, $[6] = node.icon, $[7] = node.label, $[8] = onClick, $[9] = t1, $[10] = t2) : t2 = $[10], t2;
	}
	if (node.type === "group") {
		let t1 = node.icon, t2;
		$[11] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
			arrow: !1,
			constrainSize: !0,
			placement: "right-start",
			fallbackPlacements: [
				"left-start",
				"right",
				"left",
				"right-end",
				"left-end",
				"bottom",
				"top"
			],
			preventOverflow: !0,
			__unstable_margins: POPOVER_MARGINS
		}, $[11] = t2) : t2 = $[11];
		let t3 = node.label, t4;
		if ($[12] !== boundaryElement || $[13] !== node.items || $[14] !== onDismiss) {
			let t5;
			$[16] !== boundaryElement || $[17] !== onDismiss ? (t5 = (item, itemIndex) => /* @__PURE__ */ jsx(ContextMenuItem, {
				node: item,
				onDismiss,
				boundaryElement
			}, itemIndex), $[16] = boundaryElement, $[17] = onDismiss, $[18] = t5) : t5 = $[18], t4 = node.items.map(t5), $[12] = boundaryElement, $[13] = node.items, $[14] = onDismiss, $[15] = t4;
		} else t4 = $[15];
		let t5;
		return $[19] !== node.icon || $[20] !== node.label || $[21] !== t4 ? (t5 = /* @__PURE__ */ jsx(MenuGroup, {
			fontSize: 1,
			icon: t1,
			padding: 2,
			popover: t2,
			gap: 2,
			text: t3,
			children: t4
		}), $[19] = node.icon, $[20] = node.label, $[21] = t4, $[22] = t5) : t5 = $[22], t5;
	}
	if (node.type === "custom") {
		let { component: Component } = node, t1;
		return $[23] !== Component || $[24] !== boundaryElement || $[25] !== sendTelemetry ? (t1 = /* @__PURE__ */ jsx(Component, {
			boundaryElement,
			sendTelemetry
		}), $[23] = Component, $[24] = boundaryElement, $[25] = sendTelemetry, $[26] = t1) : t1 = $[26], t1;
	}
	return null;
}
const ContextMenu = (props) => {
	let $ = c(43), { node, onDismiss, position: t0 } = props, { x, y } = t0, [boundaryElement, setBoundaryElement] = useState(null), { getField } = useSchema(), { getDocument } = useDocuments(), t1;
	$[0] !== getField || $[1] !== node ? (t1 = getField(node), $[0] = getField, $[1] = node, $[2] = t1) : t1 = $[2];
	let { field, parent } = t1, title = field?.title || field?.name || "Unknown type", [items, setItems] = useState(void 0), t2, t3;
	$[3] !== field || $[4] !== getDocument || $[5] !== node || $[6] !== parent ? (t2 = () => {
		let fetchContextMenuItems = async () => {
			let doc = getDocument(node.id);
			if (!doc) return;
			let items_0 = await getContextMenuItems({
				node,
				field,
				parent,
				doc
			});
			setItems(items_0);
		};
		fetchContextMenuItems();
	}, t3 = [
		field,
		node,
		parent,
		getDocument
	], $[3] = field, $[4] = getDocument, $[5] = node, $[6] = parent, $[7] = t2, $[8] = t3) : (t2 = $[7], t3 = $[8]), useEffect(t2, t3);
	let t4;
	$[9] !== x || $[10] !== y ? (t4 = { getBoundingClientRect: () => ({
		bottom: y,
		left: x,
		right: x,
		top: y,
		width: 0,
		height: 0
	}) }, $[9] = x, $[10] = y, $[11] = t4) : t4 = $[11];
	let contextMenuReferenceElement = t4, t5;
	$[12] === field ? t5 = $[13] : (t5 = getNodeIcon(field), $[12] = field, $[13] = t5);
	let icon = t5, t6;
	$[14] === Symbol.for("react.memo_cache_sentinel") ? (t6 = {
		minWidth: 120,
		maxWidth: 160
	}, $[14] = t6) : t6 = $[14];
	let t7;
	$[15] !== icon || $[16] !== items ? (t7 = /* @__PURE__ */ jsx(Box, {
		flex: "none",
		children: items ? /* @__PURE__ */ jsx(Text, {
			size: 1,
			children: icon
		}) : /* @__PURE__ */ jsx(Spinner, { size: 1 })
	}), $[15] = icon, $[16] = items, $[17] = t7) : t7 = $[17];
	let t8 = items ? title : "Loading...", t9;
	$[18] === t8 ? t9 = $[19] : (t9 = /* @__PURE__ */ jsx(Stack, {
		flex: 1,
		gap: 2,
		children: /* @__PURE__ */ jsx(Text, {
			size: 1,
			weight: "semibold",
			children: t8
		})
	}), $[18] = t8, $[19] = t9);
	let t10;
	$[20] !== t7 || $[21] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, {
		gap: 2,
		padding: 2,
		children: [t7, t9]
	}), $[20] = t7, $[21] = t9, $[22] = t10) : t10 = $[22];
	let t11;
	$[23] !== boundaryElement || $[24] !== items || $[25] !== onDismiss ? (t11 = items && /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(MenuDivider, {}), items.map((item, i) => /* @__PURE__ */ jsx(ContextMenuItem, {
		node: item,
		onDismiss,
		boundaryElement
	}, i))] }), $[23] = boundaryElement, $[24] = items, $[25] = onDismiss, $[26] = t11) : t11 = $[26];
	let t12;
	$[27] !== t10 || $[28] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Menu, {
		style: t6,
		children: [t10, t11]
	}), $[27] = t10, $[28] = t11, $[29] = t12) : t12 = $[29];
	let t13 = `${x}-${y}`, t14;
	$[30] !== x || $[31] !== y ? (t14 = {
		position: "absolute",
		left: x,
		top: y
	}, $[30] = x, $[31] = y, $[32] = t14) : t14 = $[32];
	let t15;
	$[33] !== t13 || $[34] !== t14 ? (t15 = /* @__PURE__ */ jsx("div", { style: t14 }, t13), $[33] = t13, $[34] = t14, $[35] = t15) : t15 = $[35];
	let t16;
	$[36] !== contextMenuReferenceElement || $[37] !== t12 || $[38] !== t15 ? (t16 = /* @__PURE__ */ jsx(Popover, {
		__unstable_margins: POPOVER_MARGINS,
		arrow: !1,
		open: !0,
		placement: "right-start",
		referenceElement: contextMenuReferenceElement,
		content: t12,
		children: t15
	}), $[36] = contextMenuReferenceElement, $[37] = t12, $[38] = t15, $[39] = t16) : t16 = $[39];
	let t17;
	return $[40] !== onDismiss || $[41] !== t16 ? (t17 = /* @__PURE__ */ jsx(PopoverPortal, {
		setBoundaryElement,
		onDismiss,
		children: t16
	}), $[40] = onDismiss, $[41] = t16, $[42] = t17) : t17 = $[42], t17;
};
function getLinkHref(href, referer) {
	try {
		let parsed = new URL(href, typeof location > "u" ? void 0 : location.origin);
		if (parsed.hash) {
			let hash = new URL(getLinkHref(parsed.hash.slice(1), referer));
			return `${parsed.origin}${parsed.pathname}${parsed.search}#${hash.pathname}${hash.search}`;
		}
		return parsed.searchParams.set("preview", referer), parsed.toString();
	} catch {
		return href;
	}
}
/**
* Feature-detection query for CSS anchor positioning plus overflow fallbacks.
*
* Overlay chrome (title labels, "Open in Studio", HUD) uses this as progressive
* enhancement: browsers that match keep labels on-screen while the preview
* iframe scrolls, without the IntersectionObserver flip heuristic.
*
* Both conditions are required. `anchor-name` alone would tether labels but
* would not flip them away from the viewport edge.
*/
const CSS_ANCHOR_POSITIONING_SUPPORTS = "(anchor-name: --sanity-ve-overlay) and (position-try-fallbacks: flip-block)";
/** @internal */
function supportsCssAnchorPositioning(supportsFn = globalThis.CSS?.supports?.bind(globalThis.CSS)) {
	return supportsFn?.(CSS_ANCHOR_POSITIONING_SUPPORTS) === !0;
}
const PreviewSnapshotsContext = createContext(null);
function usePreviewSnapshots() {
	let context = useContext(PreviewSnapshotsContext);
	if (!context) throw Error("Preview Snapshots context is missing");
	return context;
}
const isReactElementOverlayComponent = (component) => isValidElement(component), overlayChromeAnchorPositioning = (insets) => css`
  @supports ${CSS_ANCHOR_POSITIONING_SUPPORTS} {
    position: fixed;
    position-anchor: --sanity-ve-overlay;
    inset: auto;
    ${insets}
    position-try-fallbacks: flip-block, flip-inline, flip-block flip-inline;
    position-try: flip-block, flip-inline, flip-block flip-inline;
  }
`, Root$3 = styled(Card)`
  background-color: var(--overlay-bg);
  border-radius: 3px;
  pointer-events: none;
  position: absolute;
  overflow: visible;
  box-shadow: var(--overlay-box-shadow);
  transition: none;

  /* Scoped so each overlay's labels bind to this box, not the last overlay on the page. */
  anchor-name: --sanity-ve-overlay;
  anchor-scope: --sanity-ve-overlay;

  --overlay-bg: transparent;
  --overlay-box-shadow: inset 0 0 0 1px transparent;

  [data-overlays] & {
    --overlay-bg: color-mix(in srgb, transparent 95%, var(--card-focus-ring-color));
    --overlay-box-shadow: inset 0 0 0 2px
      color-mix(in srgb, transparent 50%, var(--card-focus-ring-color));
  }

  [data-fading-out] & {
    transition:
      box-shadow 1550ms,
      background-color 1550ms;

    --overlay-bg: rgba(0, 0, 255, 0);
    --overlay-box-shadow: inset 0 0 0 1px transparent;
  }

  &[data-focused] {
    --overlay-box-shadow: inset 0 0 0 1px var(--card-focus-ring-color);
  }

  &[data-hovered]:not([data-focused]) {
    transition: none;
    --overlay-box-shadow: inset 0 0 0 2px var(--card-focus-ring-color);
  }

  /* [data-unmounted] & {
    --overlay-box-shadow: inset 0 0 0 1px var(--card-focus-ring-color);
  } */

  :link {
    text-decoration: none;
  }
`, Actions = styled(Flex)`
  bottom: 100%;
  cursor: pointer;
  pointer-events: none;
  position: absolute;
  right: 0;

  [data-hovered]:not([data-menu-open]) & {
    pointer-events: all;
  }

  [data-flipped] & {
    bottom: auto;
    top: 100%;
  }

  ${overlayChromeAnchorPositioning(css`
    bottom: anchor(top);
    right: anchor(right);
  `)}
`, HUD = styled(Flex)`
  top: 100%;
  cursor: pointer;
  pointer-events: none;
  position: absolute;
  left: 0;

  gap: 4px;
  padding: 4px 0;
  flex-wrap: wrap;

  [data-hovered]:not([data-menu-open]) & {
    pointer-events: all;
  }

  [data-flipped] & {
    top: calc(100% + 2rem);
  }

  ${overlayChromeAnchorPositioning(css`
    top: anchor(bottom);
    left: anchor(left);
  `)}
`, MenuWrapper = styled(Flex)`
  margin: -0.5rem;

  [data-hovered]:not([data-menu-open]) & {
    pointer-events: all;
  }
`, Tab$1 = styled(Flex)`
  bottom: 100%;
  cursor: pointer;
  pointer-events: none;
  position: absolute;
  left: 0;

  [data-hovered]:not([data-menu-open]) & {
    pointer-events: all;
  }

  [data-flipped] & {
    bottom: auto;
    top: 100%;
  }

  ${overlayChromeAnchorPositioning(css`
    bottom: anchor(top);
    left: anchor(left);
  `)}
`, ActionOpen = styled(Card)`
  cursor: pointer;
  background-color: var(--card-focus-ring-color);
  right: 0;
  border-radius: 3px;

  & [data-ui='Text'] {
    color: #fff;
    white-space: nowrap;
  }
`, Labels = styled(Flex)`
  display: flex;
  align-items: center;
  background-color: var(--card-focus-ring-color);
  right: 0;
  border-radius: 3px;
  & [data-ui='Text'],
  & [data-sanity-icon] {
    color: #fff;
    white-space: nowrap;
  }
`, ExclusivePluginContainer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: all;
`;
function createIntentLink(node) {
	let { id, type, path, baseUrl, tool, workspace, perspective } = node, [url, search] = createEditUrl({
		baseUrl,
		workspace,
		tool,
		type,
		id,
		path: path ? pathToUrlString(studioPath.fromString(path)) : []
	}).split("?"), searchParams = new URLSearchParams(search), resolvedPerspective = perspective || searchParams.get("perspective");
	return resolvedPerspective === "drafts" ? searchParams.delete("perspective") : resolvedPerspective && searchParams.set("perspective", resolvedPerspective), `${url}?${searchParams}`;
}
const ElementOverlayInner = (props) => {
	let $ = c(60), { id, element, focused, componentResolver, node, showActions, draggable, targets, elementType, comlink, onActivateExclusivePlugin, onMenuOpenChange, inFrame } = props, { getField, getType } = useSchema(), t0;
	$[0] !== getType || $[1] !== node ? (t0 = getType(node), $[0] = getType, $[1] = node, $[2] = t0) : t0 = $[2];
	let schemaType = t0, t1;
	$[3] === node ? t1 = $[4] : (t1 = "path" in node ? createIntentLink(node) : node.href, $[3] = node, $[4] = t1);
	let href = t1, previewSnapshots = usePreviewSnapshots(), t2;
	bb0: {
		if (!("path" in node)) {
			t2 = void 0;
			break bb0;
		}
		let t3;
		$[5] !== node || $[6] !== previewSnapshots ? (t3 = previewSnapshots.find((snapshot) => snapshot._id === node.id)?.title, $[5] = node, $[6] = previewSnapshots, $[7] = t3) : t3 = $[7], t2 = t3;
	}
	let title = t2, t3;
	$[8] !== element || $[9] !== focused || $[10] !== getField || $[11] !== getType ? (t3 = function getContext(node_0, nodeElement) {
		let schemaType_0 = getType(node_0), { field, parent } = getField(node_0);
		if (!("id" in node_0) || !field || !schemaType_0) return;
		let type = field.value.type;
		return {
			document: schemaType_0,
			element,
			targetElement: nodeElement || element,
			field,
			focused: !!focused,
			node: node_0,
			parent,
			type
		};
	}, $[8] = element, $[9] = focused, $[10] = getField, $[11] = getType, $[12] = t3) : t3 = $[12];
	let getContext = t3, t4;
	$[13] !== elementType || $[14] !== getContext || $[15] !== node ? (t4 = elementType === "element" ? getContext(node) : void 0, $[13] = elementType, $[14] = getContext, $[15] = node, $[16] = t4) : t4 = $[16];
	let t5;
	if ($[17] !== getContext || $[18] !== targets) {
		let t6;
		$[20] === getContext ? t6 = $[21] : (t6 = (target) => getContext(target.sanity, target.element), $[20] = getContext, $[21] = t6), t5 = targets.map(t6).filter(_temp$9), $[17] = getContext, $[18] = targets, $[19] = t5;
	} else t5 = $[19];
	let t6;
	$[22] !== t4 || $[23] !== t5 ? (t6 = {
		legacyComponentContext: t4,
		pluginContexts: t5
	}, $[22] = t4, $[23] = t5, $[24] = t6) : t6 = $[24];
	let resolverContexts = t6, customComponents = useCustomComponents(resolverContexts.legacyComponentContext, componentResolver), nodePluginCollections = useResolvedNodePlugins(resolverContexts.pluginContexts, props.plugins), t7;
	$[25] === schemaType ? t7 = $[26] : (t7 = schemaType?.icon ? /* @__PURE__ */ jsx("div", { dangerouslySetInnerHTML: { __html: schemaType.icon } }) : /* @__PURE__ */ jsx(DocumentIcon, {}), $[25] = schemaType, $[26] = t7);
	let icon = t7, menuId = useId(), t8;
	$[27] === nodePluginCollections ? t8 = $[28] : (t8 = nodePluginCollections?.some(_temp2$6), $[27] = nodePluginCollections, $[28] = t8);
	let showMenu = t8 || nodePluginCollections?.length > 1, t9;
	$[29] === id ? t9 = $[30] : (t9 = () => {
		window.dispatchEvent(new CustomEvent("sanity-overlay/label-click", { detail: { id } }));
	}, $[29] = id, $[30] = t9);
	let handleLabelClick = t9, t10;
	$[31] !== href || $[32] !== inFrame || $[33] !== showActions ? (t10 = showActions ? /* @__PURE__ */ jsx(Actions, {
		gap: 1,
		paddingY: 1,
		children: /* @__PURE__ */ jsx(Link, {
			inFrame,
			href
		})
	}) : null, $[31] = href, $[32] = inFrame, $[33] = showActions, $[34] = t10) : t10 = $[34];
	let t11;
	$[35] !== comlink || $[36] !== draggable || $[37] !== handleLabelClick || $[38] !== icon || $[39] !== menuId || $[40] !== nodePluginCollections || $[41] !== onActivateExclusivePlugin || $[42] !== onMenuOpenChange || $[43] !== showMenu || $[44] !== title ? (t11 = (title || showMenu) && /* @__PURE__ */ jsx(Tab$1, {
		gap: 1,
		paddingY: 1,
		onClick: handleLabelClick,
		children: /* @__PURE__ */ jsxs(Labels, {
			gap: 2,
			padding: 2,
			children: [
				draggable && /* @__PURE__ */ jsx(Box, {
					marginRight: 1,
					children: /* @__PURE__ */ jsx(Text, {
						className: "drag-handle",
						size: 0,
						children: /* @__PURE__ */ jsx(DragHandleIcon, {})
					})
				}),
				/* @__PURE__ */ jsx(Text, {
					size: 0,
					children: icon
				}),
				title && /* @__PURE__ */ jsx(Text, {
					size: 1,
					weight: "medium",
					children: title
				}),
				showMenu && /* @__PURE__ */ jsx(Box, {
					paddingLeft: 2,
					onClick: _temp3$2,
					children: /* @__PURE__ */ jsx(MenuWrapper, { children: /* @__PURE__ */ jsx(MenuButton, {
						id: menuId,
						popover: {
							animate: !0,
							placement: "bottom-start",
							constrainSize: !0,
							tone: "default"
						},
						onOpen: () => {
							onMenuOpenChange?.(!0);
						},
						onClose: () => {
							onMenuOpenChange?.(!1);
						},
						button: /* @__PURE__ */ jsx(Button, {
							icon: EllipsisVerticalIcon,
							tone: "primary",
							padding: 2
						}),
						menu: /* @__PURE__ */ jsx(Menu, {
							paddingY: 0,
							children: /* @__PURE__ */ jsx(PointerEvents, { children: nodePluginCollections?.map((nodePluginCollection_0, index) => /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsxs(Stack, {
								role: "group",
								paddingY: 1,
								gap: 0,
								children: [/* @__PURE__ */ jsx(MenuItem, {
									paddingY: 2,
									text: /* @__PURE__ */ jsx(Box, {
										paddingY: 2,
										children: /* @__PURE__ */ jsx(Text, {
											muted: !0,
											size: 1,
											style: { textTransform: "capitalize" },
											children: `${nodePluginCollection_0.context.document.name}: ${nodePluginCollection_0.context.field?.name}`
										})
									}),
									onClick: () => {
										nodePluginCollection_0.context.node && comlink?.post("visual-editing/focus", nodePluginCollection_0.context.node);
									}
								}), nodePluginCollection_0.exclusive.map((exclusive) => exclusive.component ? /* @__PURE__ */ jsx(MenuItem, {
									paddingY: 2,
									icon: exclusive.icon || /* @__PURE__ */ jsx(PlugIcon, {}),
									text: /* @__PURE__ */ jsx(Box, {
										paddingY: 2,
										children: /* @__PURE__ */ jsx(Text, {
											size: 1,
											children: exclusive.title || exclusive.name
										})
									}),
									onClick: () => onActivateExclusivePlugin?.(exclusive, nodePluginCollection_0.context)
								}, exclusive.name) : null)]
							}), index < nodePluginCollections.length - 1 && /* @__PURE__ */ jsx(MenuDivider, {})] }, nodePluginCollection_0.id)) })
						})
					}) })
				})
			]
		})
	}), $[35] = comlink, $[36] = draggable, $[37] = handleLabelClick, $[38] = icon, $[39] = menuId, $[40] = nodePluginCollections, $[41] = onActivateExclusivePlugin, $[42] = onMenuOpenChange, $[43] = showMenu, $[44] = title, $[45] = t11) : t11 = $[45];
	let t12;
	$[46] === nodePluginCollections ? t12 = $[47] : (t12 = nodePluginCollections?.map(_temp4$1), $[46] = nodePluginCollections, $[47] = t12);
	let t13;
	$[48] === t12 ? t13 = $[49] : (t13 = /* @__PURE__ */ jsx(HUD, { children: t12 }), $[48] = t12, $[49] = t13);
	let t14;
	$[50] !== t10 || $[51] !== t11 || $[52] !== t13 ? (t14 = /* @__PURE__ */ jsxs(PointerEvents, { children: [
		t10,
		t11,
		t13
	] }), $[50] = t10, $[51] = t11, $[52] = t13, $[53] = t14) : t14 = $[53];
	let t15;
	$[54] !== customComponents || $[55] !== resolverContexts.legacyComponentContext ? (t15 = Array.isArray(customComponents) ? customComponents.map((t16, i) => {
		let { component: Component_1, props: props_0 } = t16;
		return /* @__PURE__ */ jsx(Component_1, {
			PointerEvents,
			...resolverContexts.legacyComponentContext,
			...props_0
		}, i);
	}) : customComponents, $[54] = customComponents, $[55] = resolverContexts.legacyComponentContext, $[56] = t15) : t15 = $[56];
	let t16;
	return $[57] !== t14 || $[58] !== t15 ? (t16 = /* @__PURE__ */ jsxs(Fragment$1, { children: [t14, t15] }), $[57] = t14, $[58] = t15, $[59] = t16) : t16 = $[59], t16;
}, ElementOverlay = memo(function ElementOverlay(props) {
	let $ = c(38), { draggable, focused, hovered, rect, wasMaybeCollapsed, enableScrollIntoView, inFrame } = props, ref = useRef(null), scrolledIntoViewRef = useRef(!1), t0 = `${rect.w}px`, t1 = `${rect.h}px`, t2 = `${rect.y}px`, t3 = `${rect.x}px`, t4;
	$[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 ? (t4 = {
		width: t0,
		height: t1,
		top: t2,
		left: t3
	}, $[0] = t0, $[1] = t1, $[2] = t2, $[3] = t3, $[4] = t4) : t4 = $[4];
	let style = t4, t5, t6;
	$[5] !== enableScrollIntoView || $[6] !== focused || $[7] !== wasMaybeCollapsed ? (t5 = () => {
		if (!scrolledIntoViewRef.current && !wasMaybeCollapsed && focused === !0 && ref.current && enableScrollIntoView) {
			let target = ref.current;
			scrollIntoView(ref.current, {
				behavior: (actions) => {
					actions.length !== 0 && target.scrollIntoView({
						behavior: "smooth",
						block: "center",
						inline: "nearest"
					});
				},
				scrollMode: "if-needed",
				block: "center",
				inline: "nearest"
			});
		}
		scrolledIntoViewRef.current = focused === !0;
	}, t6 = [
		focused,
		wasMaybeCollapsed,
		enableScrollIntoView
	], $[5] = enableScrollIntoView, $[6] = focused, $[7] = wasMaybeCollapsed, $[8] = t5, $[9] = t6) : (t5 = $[8], t6 = $[9]), useEffect(t5, t6);
	let [isNearTop, setIsNearTop] = useState(!1), t7, t8;
	$[10] === hovered ? (t7 = $[11], t8 = $[12]) : (t7 = () => {
		if (supportsCssAnchorPositioning()) return;
		if (!ref.current || !hovered) {
			setIsNearTop(!1);
			return;
		}
		let io = new IntersectionObserver((t9) => {
			let [intersection] = t9;
			setIsNearTop(intersection.boundingClientRect.top < 0);
		}, { threshold: 1 });
		return io.observe(ref.current), () => io.disconnect();
	}, t8 = [hovered], $[10] = hovered, $[11] = t7, $[12] = t8), useEffect(t7, t8);
	let [activeExclusivePlugin, setActiveExclusivePlugin] = useState(null), t9;
	$[13] === Symbol.for("react.memo_cache_sentinel") ? (t9 = () => {
		setActiveExclusivePlugin(null), window.dispatchEvent(new CustomEvent("sanity-overlay/exclusive-plugin-closed"));
	}, $[13] = t9) : t9 = $[13];
	let closeExclusivePluginView = t9, t10;
	$[14] === Symbol.for("react.memo_cache_sentinel") ? (t10 = (plugin, context) => {
		setActiveExclusivePlugin({
			plugin,
			context
		});
	}, $[14] = t10) : t10 = $[14];
	let onActivateExclusivePlugin = t10, handleExclusivePluginClick = _temp5$1, ExclusivePluginComponent = activeExclusivePlugin?.plugin.component, [menuOpen, setMenuOpen] = useState(!1), t11;
	$[15] === Symbol.for("react.memo_cache_sentinel") ? (t11 = () => {
		startTransition(() => setMenuOpen(!1));
	}, $[15] = t11) : t11 = $[15];
	let t12;
	$[16] === hovered ? t12 = $[17] : (t12 = [hovered], $[16] = hovered, $[17] = t12), useEffect(t11, t12);
	let t13;
	$[18] !== ExclusivePluginComponent || $[19] !== menuOpen ? (t13 = menuOpen || ExclusivePluginComponent ? /* @__PURE__ */ jsx(PopoverBackground, {
		onDismiss: closeExclusivePluginView,
		blockScroll: menuOpen
	}) : null, $[18] = ExclusivePluginComponent, $[19] = menuOpen, $[20] = t13) : t13 = $[20];
	let t14 = focused ? "" : void 0, t15 = hovered ? "" : void 0, t16 = isNearTop ? "" : void 0, t17 = draggable ? "" : void 0, t18 = menuOpen ? "" : void 0, t19;
	$[21] !== ExclusivePluginComponent || $[22] !== activeExclusivePlugin || $[23] !== hovered || $[24] !== inFrame || $[25] !== props ? (t19 = ExclusivePluginComponent ? /* @__PURE__ */ jsx(ExclusivePluginContainer, {
		"data-sanity-overlay-element": !0,
		onClick: handleExclusivePluginClick,
		children: /* @__PURE__ */ jsx(ExclusivePluginComponent, {
			...activeExclusivePlugin.context,
			closeExclusiveView: closeExclusivePluginView
		})
	}) : hovered ? /* @__PURE__ */ jsx(ElementOverlayInner, {
		...props,
		inFrame,
		onActivateExclusivePlugin,
		onMenuOpenChange: setMenuOpen
	}) : null, $[21] = ExclusivePluginComponent, $[22] = activeExclusivePlugin, $[23] = hovered, $[24] = inFrame, $[25] = props, $[26] = t19) : t19 = $[26];
	let t20;
	$[27] !== style || $[28] !== t14 || $[29] !== t15 || $[30] !== t16 || $[31] !== t17 || $[32] !== t18 || $[33] !== t19 ? (t20 = /* @__PURE__ */ jsx(Root$3, {
		"data-focused": t14,
		"data-hovered": t15,
		"data-flipped": t16,
		"data-draggable": t17,
		"data-menu-open": t18,
		ref,
		style,
		children: t19
	}), $[27] = style, $[28] = t14, $[29] = t15, $[30] = t16, $[31] = t17, $[32] = t18, $[33] = t19, $[34] = t20) : t20 = $[34];
	let t21;
	return $[35] !== t13 || $[36] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Fragment$1, { children: [t13, t20] }), $[35] = t13, $[36] = t20, $[37] = t21) : t21 = $[37], t21;
});
function useResolvedNodePlugins(componentContexts, plugins) {
	let $ = c(5), t0;
	if ($[0] !== componentContexts || $[1] !== plugins) {
		let t1;
		$[3] === plugins ? t1 = $[4] : (t1 = (componentContext) => {
			let instance = {
				id: v4(),
				context: componentContext,
				hud: [],
				exclusive: []
			};
			return plugins?.forEach((plugin) => {
				plugin.guard?.(componentContext) && (plugin.type === "hud" && instance.hud.push(plugin), plugin.type === "exclusive" && instance.exclusive.push(plugin));
			}), instance;
		}, $[3] = plugins, $[4] = t1), t0 = componentContexts.map(t1), $[0] = componentContexts, $[1] = plugins, $[2] = t0;
	} else t0 = $[2];
	return t0;
}
function useCustomComponents(componentContext, componentResolver) {
	let $ = c(3), t0;
	if ($[0] !== componentContext || $[1] !== componentResolver) {
		bb0: {
			if (!componentContext) {
				t0 = void 0;
				break bb0;
			}
			let resolved = componentResolver?.(componentContext);
			if (!resolved) {
				t0 = void 0;
				break bb0;
			}
			if (isReactElementOverlayComponent(resolved)) {
				t0 = resolved;
				break bb0;
			}
			t0 = (Array.isArray(resolved) ? resolved : [resolved]).map(_temp6$1);
		}
		$[0] = componentContext, $[1] = componentResolver, $[2] = t0;
	} else t0 = $[2];
	return t0;
}
function _temp6$1(component) {
	return typeof component == "object" && "component" in component ? component : {
		component,
		props: {}
	};
}
const Link = memo(function Link(props) {
	let $ = c(8), { inFrame } = props, referer = useSyncExternalStore(_temp7$1, _temp8$1), t0;
	$[0] !== props.href || $[1] !== referer ? (t0 = getLinkHref(props.href, referer), $[0] = props.href, $[1] = referer, $[2] = t0) : t0 = $[2];
	let href = t0, t1 = inFrame ? void 0 : "_blank", t2 = inFrame ? "noopener" : "noopener noreferrer", t3;
	$[3] === Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(ActionOpen, {
		padding: 2,
		children: /* @__PURE__ */ jsx(Text, {
			size: 1,
			weight: "medium",
			children: "Open in Studio"
		})
	}), $[3] = t3) : t3 = $[3];
	let t4;
	return $[4] !== href || $[5] !== t1 || $[6] !== t2 ? (t4 = /* @__PURE__ */ jsx(Box, {
		as: "a",
		href,
		target: t1,
		rel: t2,
		children: t3
	}), $[4] = href, $[5] = t1, $[6] = t2, $[7] = t4) : t4 = $[7], t4;
});
function _temp$9(ctx) {
	return ctx !== void 0;
}
function _temp2$6(nodePluginCollection) {
	return nodePluginCollection.exclusive.length > 0;
}
function _temp3$2(e) {
	e.stopPropagation();
}
function _temp4$1(nodePluginCollection_1) {
	return /* @__PURE__ */ jsx(Fragment, { children: nodePluginCollection_1.hud.map((hud) => {
		let Component_0 = hud.component;
		return Component_0 ? /* @__PURE__ */ jsx(Component_0, { ...nodePluginCollection_1.context }, hud.name) : null;
	}) }, nodePluginCollection_1.id);
}
function _temp5$1(event) {
	event.stopPropagation();
}
function _temp7$1(onStoreChange) {
	let handlePopState = () => onStoreChange();
	return window.addEventListener("popstate", handlePopState), () => window.removeEventListener("popstate", handlePopState);
}
function _temp8$1() {
	return window.location.href;
}
const OverlayDragGroupRect = (t0) => {
	let $ = c(5), { dragGroupRect } = t0, t1 = `${dragGroupRect.y}px`, t2 = `${dragGroupRect.x}px`, t3 = `${dragGroupRect.w - 1}px`, t4 = `${dragGroupRect.h - 1}px`, t5;
	return $[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 ? (t5 = /* @__PURE__ */ jsx("div", { style: {
		position: "absolute",
		top: t1,
		left: t2,
		width: t3,
		height: t4,
		border: "1px dashed #f0709b",
		pointerEvents: "none"
	} }), $[0] = t1, $[1] = t2, $[2] = t3, $[3] = t4, $[4] = t5) : t5 = $[4], t5;
};
function lerp(v0, v1, t) {
	return v0 * (1 - t) + v1 * t;
}
const OverlayDragInsertMarker = (t0) => {
	let $ = c(4), { dragInsertPosition } = t0;
	if (dragInsertPosition === null) return;
	let flow = dragInsertPosition?.left || dragInsertPosition?.right ? "horizontal" : "vertical", x = 0, y = 0, width = 0, height = 0;
	if (flow === "horizontal") {
		let { left, right } = dragInsertPosition;
		if (width = 6, right && left) {
			let startX = left.rect.x + left.rect.w, endX = right.rect.x, offset = Math.min(right.rect.h, left.rect.h) * .0125;
			x = lerp(startX, endX, .5) - 3, y = left.rect.y + offset, height = Math.min(right.rect.h, left.rect.h) - offset * 2;
		} else if (right && !left) {
			let offset_0 = right.rect.h * .0125;
			x = right.rect.x - 3, y = right.rect.y + offset_0, height = right.rect.h - offset_0 * 2;
		} else if (left && !right) {
			let offset_1 = left.rect.h * .0125;
			x = left.rect.x + left.rect.w - 3, y = left.rect.y + offset_1, height = left.rect.h - offset_1 * 2;
		}
	} else {
		let { bottom, top } = dragInsertPosition;
		if (bottom && top) {
			let startX_0 = Math.min(top.rect.x, bottom.rect.x), startY = top.rect.y + top.rect.h, endY = bottom.rect.y, offset_2 = Math.min(bottom.rect.w, top.rect.w) * .0125;
			height = 6, x = startX_0 + offset_2, y = lerp(startY, endY, .5) - 3, width = Math.max(bottom.rect.w, top.rect.w) - offset_2 * 2;
		} else if (bottom && !top) {
			let offset_3 = bottom.rect.w * .0125;
			x = bottom.rect.x + offset_3, y = bottom.rect.y - 3, width = bottom.rect.w - offset_3 * 2, height = 6;
		} else if (top && !bottom) {
			let offset_4 = top.rect.w * .0125;
			x = top.rect.x + offset_4, y = top.rect.y + top.rect.h - 3, width = top.rect.w - offset_4 * 2, height = 6;
		}
	}
	let t1 = `${width}px`, t2 = `${height}px`, t3 = `translate(${x}px, ${y}px)`, t4;
	return $[0] !== t1 || $[1] !== t2 || $[2] !== t3 ? (t4 = /* @__PURE__ */ jsx("div", { style: {
		position: "absolute",
		width: t1,
		height: t2,
		transform: t3,
		background: "#556bfc",
		border: "2px solid white",
		borderRadius: "999px",
		zIndex: "999999"
	} }), $[0] = t1, $[1] = t2, $[2] = t3, $[3] = t4) : t4 = $[3], t4;
}, Root$2 = styled.div`
  --drag-preview-opacity: 0.98;
  --drag-preview-skeleton-stroke: #ffffff;

  @media (prefers-color-scheme: dark) {
    --drag-preview-skeleton-stroke: #383d51;
  }

  position: fixed;
  display: grid;
  transform: ${({ $scaleFactor, $width, $height }) => `translate(calc(var(--drag-preview-x) - ${$width / 2}px), calc(var(--drag-preview-y) - ${$height / 2}px)) scale(${$scaleFactor})`};
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}px`};
  z-index: 9999999;
  opacity: var(--drag-preview-opacity);
  cursor: move;

  .drag-preview-content-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    container-type: inline-size;
  }

  [data-ui='card'] {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .drag-preview-skeleton {
    position: absolute;
    inset: 0;

    rect {
      stroke: var(--drag-preview-skeleton-stroke);
    }
  }

  .drag-preview-handle {
    position: absolute;
    top: 4cqmin;
    left: 4cqmin;
    width: 6cqmin;
    fill: var(--drag-preview-handle-fill);
  }
`;
function clamp(number, min, max) {
	return number < min ? min : number > max ? max : number;
}
function map(number, inMin, inMax, outMin, outMax) {
	return clamp((number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin, outMin, outMax);
}
const OverlayDragPreview = (t0) => {
	let $ = c(50), { skeleton } = t0, maxSkeletonWidth = Math.min(skeleton.maxWidth, window.innerWidth / 2), scaleFactor = skeleton.w > maxSkeletonWidth ? maxSkeletonWidth / skeleton.w : 1, offsetX = skeleton.offsetX * scaleFactor, offsetY = skeleton.offsetY * scaleFactor, prefersDark = usePrefersDark(), theme = useTheme_v2(), radius = theme.radius[~~map(skeleton.w, 0, 1920, 1, theme.radius.length - 2)], T0, T1, t1, t10, t11, t12, t13, t14, t2, t3, t4, t5, t6, t7, t8, t9;
	if ($[0] !== offsetX || $[1] !== offsetY || $[2] !== prefersDark || $[3] !== radius || $[4] !== scaleFactor || $[5] !== skeleton.childRects || $[6] !== skeleton.h || $[7] !== skeleton.w) {
		let imageRects = skeleton.childRects.filter(_temp$8), textRects = skeleton.childRects.filter(_temp2$5);
		T1 = Root$2, t10 = skeleton.w, t11 = skeleton.h, t12 = offsetX, t13 = offsetY, t14 = scaleFactor, T0 = Card, t5 = radius, t6 = 4, t7 = "hidden", t8 = "transparent", t9 = prefersDark ? "dark" : "light", t4 = "drag-preview-content-wrapper", t2 = "drag-preview-skeleton", t3 = `0 0 ${skeleton.w} ${skeleton.h}`, t1 = [...imageRects, ...textRects], $[0] = offsetX, $[1] = offsetY, $[2] = prefersDark, $[3] = radius, $[4] = scaleFactor, $[5] = skeleton.childRects, $[6] = skeleton.h, $[7] = skeleton.w, $[8] = T0, $[9] = T1, $[10] = t1, $[11] = t10, $[12] = t11, $[13] = t12, $[14] = t13, $[15] = t14, $[16] = t2, $[17] = t3, $[18] = t4, $[19] = t5, $[20] = t6, $[21] = t7, $[22] = t8, $[23] = t9;
	} else T0 = $[8], T1 = $[9], t1 = $[10], t10 = $[11], t11 = $[12], t12 = $[13], t13 = $[14], t14 = $[15], t2 = $[16], t3 = $[17], t4 = $[18], t5 = $[19], t6 = $[20], t7 = $[21], t8 = $[22], t9 = $[23];
	let t15;
	$[24] !== t1 || $[25] !== theme.color ? (t15 = t1.map((r_1, i) => /* @__PURE__ */ jsx("rect", {
		x: r_1.x,
		y: r_1.y,
		width: r_1.w,
		height: r_1.h,
		fill: theme.color.skeleton.from
	}, i)), $[24] = t1, $[25] = theme.color, $[26] = t15) : t15 = $[26];
	let t16;
	$[27] !== t15 || $[28] !== t2 || $[29] !== t3 ? (t16 = /* @__PURE__ */ jsx("svg", {
		className: t2,
		viewBox: t3,
		children: t15
	}), $[27] = t15, $[28] = t2, $[29] = t3, $[30] = t16) : t16 = $[30];
	let t17;
	$[31] !== t16 || $[32] !== t4 ? (t17 = /* @__PURE__ */ jsx("div", {
		className: t4,
		children: t16
	}), $[31] = t16, $[32] = t4, $[33] = t17) : t17 = $[33];
	let t18;
	$[34] !== T0 || $[35] !== t17 || $[36] !== t5 || $[37] !== t6 || $[38] !== t7 || $[39] !== t8 || $[40] !== t9 ? (t18 = /* @__PURE__ */ jsx(T0, {
		radius: t5,
		shadow: t6,
		overflow: t7,
		tone: t8,
		scheme: t9,
		children: t17
	}), $[34] = T0, $[35] = t17, $[36] = t5, $[37] = t6, $[38] = t7, $[39] = t8, $[40] = t9, $[41] = t18) : t18 = $[41];
	let t19;
	return $[42] !== T1 || $[43] !== t10 || $[44] !== t11 || $[45] !== t12 || $[46] !== t13 || $[47] !== t14 || $[48] !== t18 ? (t19 = /* @__PURE__ */ jsx(T1, {
		$width: t10,
		$height: t11,
		$offsetX: t12,
		$offsetY: t13,
		$scaleFactor: t14,
		children: t18
	}), $[42] = T1, $[43] = t10, $[44] = t11, $[45] = t12, $[46] = t13, $[47] = t14, $[48] = t18, $[49] = t19) : t19 = $[49], t19;
};
function _temp$8(r) {
	return r.tagName === "IMG";
}
function _temp2$5(r_0) {
	return r_0.tagName !== "IMG";
}
const Root$1 = styled(Card)`
  position: fixed;
  bottom: 2rem;
  left: 2rem;
`, OverlayMinimapPrompt = () => {
	let $ = c(2), t0;
	$[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = { zIndex: "999999" }, $[0] = t0) : t0 = $[0];
	let t1;
	return $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(Root$1, {
		padding: 2,
		shadow: 2,
		radius: 2,
		style: t0,
		children: /* @__PURE__ */ jsxs(Flex, {
			align: "center",
			gap: 2,
			children: [
				/* @__PURE__ */ jsx(Hotkeys, { keys: ["Shift"] }),
				/* @__PURE__ */ jsx(Text, {
					size: 1,
					children: "Zoom Out"
				}),
				/* @__PURE__ */ jsx(ExpandIcon, {})
			]
		})
	}), $[1] = t1) : t1 = $[1], t1;
}, elementsReducer = (elements, message) => {
	let { type } = message;
	switch (type) {
		case "element/register": return elements.find((e) => e.id === message.id) ? elements : [...elements, {
			id: message.id,
			activated: !1,
			element: message.element,
			focused: !1,
			hovered: !1,
			rect: message.rect,
			sanity: message.sanity,
			dragDisabled: message.dragDisabled,
			targets: message.targets,
			elementType: message.elementType
		}];
		case "element/activate": return elements.map((e) => e.id === message.id ? {
			...e,
			activated: !0
		} : e);
		case "element/update": return elements.map((e) => e.id === message.id ? {
			...e,
			sanity: message.sanity,
			rect: message.rect,
			targets: message.targets,
			elementType: message.elementType
		} : e);
		case "element/unregister": return elements.filter((e) => e.id !== message.id);
		case "element/deactivate": return elements.map((e) => e.id === message.id ? {
			...e,
			activated: !1,
			hovered: !1
		} : e);
		case "element/mouseenter": return elements.map((e) => e.id === message.id ? {
			...e,
			rect: message.rect,
			hovered: !0
		} : {
			...e,
			hovered: !1
		});
		case "element/mouseleave": return elements.map((element) => element.id === message.id ? {
			...element,
			hovered: !1
		} : element);
		case "element/updateRect": return elements.map((element) => element.id === message.id ? {
			...element,
			rect: message.rect
		} : element);
		case "element/click": return elements.map((e) => ({
			...e,
			focused: e.id === message.id && "clicked"
		}));
		case "overlay/reset-mouse-state": return elements.map((e) => ({
			...e,
			focused: !1,
			hovered: !1
		}));
		case "overlay/blur": return elements.map((e) => ({
			...e,
			focused: !1
		}));
		case "presentation/blur": return elements.map((e) => ({
			...e,
			focused: !1
		}));
		case "presentation/focus": {
			let clickedElement = elements.find((e) => e.focused === "clicked");
			return elements.map((e) => {
				let focused = "path" in e.sanity && e.sanity.id === message.data.id && e.sanity.path === message.data.path;
				return clickedElement && e === clickedElement && focused ? e : {
					...e,
					focused: focused && clickedElement ? "duplicate" : focused
				};
			});
		}
		default: return elements;
	}
};
function overlayStateReducer(state, message) {
	let { type } = message, { contextMenu, focusPath, perspective, variant, isDragging, dragInsertPosition, dragShowMinimap, dragShowMinimapPrompt, dragSkeleton, dragMinimapTransition, dragGroupRect } = state, wasMaybeCollapsed = !1;
	if (type === "presentation/focus") {
		let prevFocusPath = state.focusPath;
		focusPath = message.data.path, prevFocusPath !== focusPath && (wasMaybeCollapsed = prevFocusPath.slice(focusPath.length).startsWith("["));
	}
	return type === "presentation/perspective" && (perspective = message.data.perspective, variant = message.data.variant || void 0), type === "element/contextmenu" && (contextMenu = "sanity" in message ? {
		node: message.sanity,
		position: message.position
	} : null), (type === "element/click" || type === "element/mouseleave" || type === "overlay/blur" || type === "presentation/blur" || type === "presentation/focus") && (contextMenu = null), type === "overlay/dragUpdateInsertPosition" && (dragInsertPosition = message.insertPosition), type === "overlay/dragStart" && (isDragging = !0), message.type === "overlay/dragUpdateSkeleton" && (dragSkeleton = message.skeleton), type === "overlay/dragEnd" && (isDragging = !1), message.type === "overlay/dragToggleMinimapPrompt" && (dragShowMinimapPrompt = message.display), type === "overlay/dragStartMinimapTransition" && (dragMinimapTransition = !0), type === "overlay/dragEndMinimapTransition" && (dragMinimapTransition = !1), type === "overlay/dragUpdateGroupRect" && (dragGroupRect = message.groupRect), type === "overlay/dragToggleMinimap" && (dragShowMinimap = message.display), {
		...state,
		contextMenu,
		elements: elementsReducer(state.elements, message),
		dragInsertPosition,
		dragSkeleton,
		dragGroupRect,
		isDragging,
		focusPath,
		perspective,
		variant,
		wasMaybeCollapsed,
		dragShowMinimap,
		dragShowMinimapPrompt,
		dragMinimapTransition
	};
}
const PreviewSnapshotsProvider = function(props) {
	let $ = c(13), { comlink, children } = props, t0;
	$[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
	let [previewSnapshots, setPreviewSnapshots] = useState(t0), t1;
	$[1] === comlink ? t1 = $[2] : (t1 = async (signal) => {
		if (comlink) try {
			let response = await comlink.fetch("visual-editing/preview-snapshots", void 0, {
				signal,
				suppressWarnings: !0
			});
			setPreviewSnapshots(response.snapshots);
		} catch {}
	}, $[1] = comlink, $[2] = t1);
	let fetchPreviewSnapshots = t1, t2, t3;
	$[3] !== comlink || $[4] !== fetchPreviewSnapshots ? (t2 = () => {
		if (!comlink) return;
		let previewSapshotsFetch = new AbortController(), unsub = comlink.onStatus(() => {
			fetchPreviewSnapshots(previewSapshotsFetch.signal);
		}, "connected");
		return () => {
			previewSapshotsFetch.abort(), unsub();
		};
	}, t3 = [comlink, fetchPreviewSnapshots], $[3] = comlink, $[4] = fetchPreviewSnapshots, $[5] = t2, $[6] = t3) : (t2 = $[5], t3 = $[6]), useEffect(t2, t3);
	let t4, t5;
	$[7] === comlink ? (t4 = $[8], t5 = $[9]) : (t4 = () => comlink?.on("presentation/preview-snapshots", (data) => {
		setPreviewSnapshots(data.snapshots);
	}), t5 = [comlink], $[7] = comlink, $[8] = t4, $[9] = t5), useEffect(t4, t5);
	let context = previewSnapshots, t6;
	return $[10] !== children || $[11] !== context ? (t6 = /* @__PURE__ */ jsx(PreviewSnapshotsContext.Provider, {
		value: context,
		children
	}), $[10] = children, $[11] = context, $[12] = t6) : t6 = $[12], t6;
};
function isSanityNode(node) {
	return "path" in node;
}
function isDocumentSchemaType(type) {
	return type.type === "document";
}
function isTypeSchemaType(type) {
	return type.type === "type";
}
function popUnkeyedPathSegments(path) {
	return path.split(".").toReversed().reduce((acc, part) => acc.length ? [part, ...acc] : part.includes("[_key==") ? [part] : [], []).join(".");
}
function getPathsWithUnresolvedTypes(elements) {
	return elements.reduce((acc, element) => {
		let { sanity } = element;
		if (!("id" in sanity) || !sanity.path.includes("[_key==")) return acc;
		let path = popUnkeyedPathSegments(sanity.path);
		return acc.find((item) => item.id === sanity.id && item.path === path) || acc.push({
			id: sanity.id,
			path
		}), acc;
	}, []);
}
const SchemaProvider = function(props) {
	let $ = c(22), { comlink, children, elements } = props, t0;
	$[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ new Map(), $[0] = t0) : t0 = $[0];
	let [resolvedTypes, setResolvedTypes] = useState(t0), [schema, setSchema] = useState(null), t1, t2;
	$[1] === comlink ? (t1 = $[2], t2 = $[3]) : (t1 = () => {
		if (!comlink) return;
		let fetchSchema = async function fetchSchema(signal) {
			if (comlink) try {
				let response = await comlink.fetch("visual-editing/schema", void 0, {
					signal,
					suppressWarnings: !0
				});
				setSchema(response.schema);
			} catch {}
		}, schemaFetch = new AbortController(), unsub = comlink.onStatus(() => {
			fetchSchema(schemaFetch.signal);
		}, "connected");
		return () => {
			schemaFetch.abort(), unsub();
		};
	}, t2 = [comlink], $[1] = comlink, $[2] = t1, $[3] = t2), useEffect(t1, t2);
	let t3;
	$[4] === Symbol.for("react.memo_cache_sentinel") ? (t3 = [], $[4] = t3) : t3 = $[4];
	let reportedPathsRef = useRef(t3), t4 = useDeferredValue(elements), t5;
	$[5] === t4 ? t5 = $[6] : (t5 = getPathsWithUnresolvedTypes(t4), $[5] = t4, $[6] = t5);
	let paths = t5, controllerRef = useRef(null), t6, t7;
	$[7] !== comlink || $[8] !== paths ? (t6 = () => {
		if (!paths.length || !comlink) return;
		let reportPaths = async (paths_0, signal_0) => {
			let initialReportedPaths = reportedPathsRef.current;
			try {
				reportedPathsRef.current = paths_0;
				let response_0 = await comlink.fetch("visual-editing/schema-union-types", { paths: paths_0 }, {
					signal: signal_0,
					suppressWarnings: !0
				});
				if (signal_0.aborted) return;
				setResolvedTypes(response_0.types), controllerRef.current = null;
			} catch {}
			signal_0.aborted && (reportedPathsRef.current = initialReportedPaths);
		};
		paths.some((p) => !reportedPathsRef.current.find((t8) => {
			let { id, path } = t8;
			return id === p.id && path === p.path;
		})) && (controllerRef.current?.abort(), controllerRef.current = new AbortController(), reportPaths(paths, controllerRef.current.signal));
	}, t7 = [comlink, paths], $[7] = comlink, $[8] = paths, $[9] = t6, $[10] = t7) : (t6 = $[9], t7 = $[10]), useEffect(t6, t7);
	let t8;
	$[11] === schema ? t8 = $[12] : (t8 = (node, _type) => {
		let type = _type || "document";
		if (!schema || typeof node != "string" && (!isSanityNode(node) || !Array.isArray(schema))) return;
		let name = typeof node == "string" ? node : node.type, filter = type === "document" ? isDocumentSchemaType : isTypeSchemaType;
		return schema.filter(filter).find((schemaType) => schemaType.name === name);
	}, $[11] = schema, $[12] = t8);
	let getType = t8, t9;
	$[13] !== getType || $[14] !== resolvedTypes ? (t9 = (node_0) => {
		if (!isSanityNode(node_0)) return {
			field: void 0,
			parent: void 0
		};
		let schemaType_0 = getType(node_0);
		if (!schemaType_0) return {
			field: void 0,
			parent: void 0
		};
		function fieldFromPath(schemaType_1, path_0, parent, t10) {
			let prevPath = t10 === void 0 ? [] : t10;
			if (!schemaType_1) return {
				field: void 0,
				parent: void 0
			};
			let [next, ...rest] = path_0;
			if ("fields" in schemaType_1) {
				let objectField = schemaType_1.fields[next];
				if (!objectField && "rest" in schemaType_1) return fieldFromPath(schemaType_1.rest, path_0, schemaType_1, prevPath);
				if (!rest.length) return {
					field: objectField,
					parent
				};
				if (!objectField) throw Error(`[@sanity/visual-editing] No field could be resolved at path: "${[...prevPath, ...path_0].join(".")}"`);
				return fieldFromPath(objectField.value, rest, schemaType_1, [...prevPath, next]);
			}
			if (schemaType_1.type === "array") return fieldFromPath(schemaType_1.of, path_0, schemaType_1, prevPath);
			if (schemaType_1.type === "arrayItem") return rest.length ? fieldFromPath(schemaType_1.value, rest, schemaType_1, [...prevPath, next]) : {
				field: schemaType_1,
				parent
			};
			if (schemaType_1.type === "union") {
				let name_0 = next.startsWith("[_key==") ? resolvedTypes?.get(node_0.id)?.get([prevPath.join("."), next].filter(Boolean).join("")) : next;
				return fieldFromPath(schemaType_1.of.find((item) => item.type === "unionOption" ? item.name === name_0 : item), rest, schemaType_1, [...prevPath, next]);
			}
			if (schemaType_1.type === "unionOption") return next ? fieldFromPath(schemaType_1.value, path_0, schemaType_1, prevPath) : {
				field: schemaType_1,
				parent
			};
			if (schemaType_1.type === "inline") return fieldFromPath(getType(schemaType_1.name, "type").value, path_0, schemaType_1, prevPath);
			throw Error(`[@sanity/visual-editing] No field could be resolved at path: "${[...prevPath, ...path_0].join(".")}"`);
		}
		let nodePath = node_0.path.split(".").flatMap(_temp$7);
		try {
			return fieldFromPath(schemaType_0, nodePath, void 0);
		} catch (t11) {
			let e = t11;
			return e instanceof Error && console.warn(e.message), {
				field: void 0,
				parent: void 0
			};
		}
	}, $[13] = getType, $[14] = resolvedTypes, $[15] = t9) : t9 = $[15];
	let getField = t9, t10;
	$[16] !== getField || $[17] !== getType ? (t10 = {
		getField,
		getType
	}, $[16] = getField, $[17] = getType, $[18] = t10) : t10 = $[18];
	let context = t10, t11;
	return $[19] !== children || $[20] !== context ? (t11 = /* @__PURE__ */ jsx(SchemaContext.Provider, {
		value: context,
		children
	}), $[19] = children, $[20] = context, $[21] = t11) : t11 = $[21], t11;
};
function _temp$7(part) {
	return part.includes("[") ? part.split(/(\[.+\])/, 2) : [part];
}
const createStore = (initialState) => {
	let state = initialState, getState = () => state, listeners = /* @__PURE__ */ new Set(), setState = (fn) => {
		state = fn(state), listeners.forEach((l) => l());
	}, subscribe = (listener) => (listeners.add(listener), () => listeners.delete(listener));
	return {
		getState,
		setState,
		subscribe
	};
}, store = createStore({}), SharedStateProvider = (props) => {
	let $ = c(11), { comlink, children } = props, t0, t1;
	$[0] === comlink ? (t0 = $[1], t1 = $[2]) : (t0 = () => comlink?.on("presentation/shared-state", _temp$6), t1 = [comlink], $[0] = comlink, $[1] = t0, $[2] = t1), useEffect(t0, t1);
	let t2, t3;
	$[3] === comlink ? (t2 = $[4], t3 = $[5]) : (t2 = () => {
		(async function fetch() {
			let value = await comlink?.fetch("visual-editing/shared-state", void 0, { suppressWarnings: !0 });
			value && store.setState(() => value.state);
		})().catch(_temp2$4);
	}, t3 = [comlink], $[3] = comlink, $[4] = t2, $[5] = t3), useEffect(t2, t3);
	let t4;
	$[6] === comlink ? t4 = $[7] : (t4 = {
		comlink,
		store
	}, $[6] = comlink, $[7] = t4);
	let value_0 = t4, t5;
	return $[8] !== children || $[9] !== value_0 ? (t5 = /* @__PURE__ */ jsx(SharedStateContext.Provider, {
		value: value_0,
		children
	}), $[8] = children, $[9] = value_0, $[10] = t5) : t5 = $[10], t5;
};
function _temp$6(data) {
	"value" in data ? store.setState((prev) => ({
		...prev,
		[data.key]: data.value
	})) : store.setState((prev_0) => Object.fromEntries(Object.entries(prev_0).filter((t0) => {
		let [key] = t0;
		return key !== data.key;
	})));
}
function _temp2$4(reason) {
	console.debug(reason), console.warn("[@sanity/visual-editing]: Failed to fetch shared state. Check your version of `sanity` is up-to-date");
}
const TelemetryProvider = (t0) => {
	let $ = c(5), { children, comlink } = t0, t1;
	$[0] === comlink ? t1 = $[1] : (t1 = (name, data) => {
		if (!comlink) return;
		let event = events[name];
		if (event) comlink.post("visual-editing/telemetry-log", {
			event,
			data
		});
		else throw Error(`Telemetry event: ${name} does not exist`);
	}, $[0] = comlink, $[1] = t1);
	let log = t1, t2;
	return $[2] !== children || $[3] !== log ? (t2 = /* @__PURE__ */ jsx(TelemetryContext.Provider, {
		value: log,
		children
	}), $[2] = children, $[3] = log, $[4] = t2) : t2 = $[4], t2;
};
/**
* Hook for using an overlay controller
* @internal
*/
function useController(element, handler, inFrame, inPopUp) {
	let $ = c(7), overlayController = useRef(void 0), optimisticActorReady = useOptimisticActorReady(), t0, t1;
	return $[0] !== element || $[1] !== handler || $[2] !== inFrame || $[3] !== inPopUp || $[4] !== optimisticActorReady ? (t0 = () => {
		if (element) return overlayController.current = createOverlayController({
			handler,
			overlayElement: element,
			inFrame,
			inPopUp,
			optimisticActorReady
		}), () => {
			overlayController.current?.destroy(), overlayController.current = void 0;
		};
	}, t1 = [
		element,
		handler,
		inFrame,
		inPopUp,
		optimisticActorReady
	], $[0] = element, $[1] = handler, $[2] = inFrame, $[3] = inPopUp, $[4] = optimisticActorReady, $[5] = t0, $[6] = t1) : (t0 = $[5], t1 = $[6]), useEffect(t0, t1), overlayController;
}
function usePerspectiveSync(comlink, dispatch, onPerspectiveChange, onVariantChange) {
	let $ = c(14), handlesPerspectiveChange = !!onPerspectiveChange, handlesVariantChange = !!onVariantChange, t0;
	$[0] !== dispatch || $[1] !== onPerspectiveChange || $[2] !== onVariantChange ? (t0 = (data) => {
		dispatch({
			type: "presentation/perspective",
			data
		}), onPerspectiveChange?.(data.perspective), onVariantChange?.(data.variant || void 0);
	}, $[0] = dispatch, $[1] = onPerspectiveChange, $[2] = onVariantChange, $[3] = t0) : t0 = $[3];
	let handlePerspective = useEffectEvent(t0), t1;
	$[4] !== comlink || $[5] !== handlePerspective || $[6] !== handlesPerspectiveChange || $[7] !== handlesVariantChange ? (t1 = () => {
		let controller = new AbortController();
		comlink?.fetch("visual-editing/fetch-perspective", {
			handlesPerspectiveChange,
			handlesVariantChange
		}, {
			signal: controller.signal,
			suppressWarnings: !0
		}).then((data_0) => {
			handlePerspective(data_0);
		}).catch(_temp$5);
		let unsub = comlink?.on("presentation/perspective", (data_1) => {
			handlePerspective(data_1);
		});
		return () => {
			unsub?.(), controller.abort();
		};
	}, $[4] = comlink, $[5] = handlePerspective, $[6] = handlesPerspectiveChange, $[7] = handlesVariantChange, $[8] = t1) : t1 = $[8];
	let t2;
	$[9] !== comlink || $[10] !== dispatch || $[11] !== handlesPerspectiveChange || $[12] !== handlesVariantChange ? (t2 = [
		comlink,
		dispatch,
		handlesPerspectiveChange,
		handlesVariantChange
	], $[9] = comlink, $[10] = dispatch, $[11] = handlesPerspectiveChange, $[12] = handlesVariantChange, $[13] = t2) : t2 = $[13], useEffect(t1, t2);
}
function _temp$5() {}
/**
* Orders elements by visual position (top-to-bottom, left-to-right), maps each
* to its SanityNode, and de-duplicates by id — keeping the first (topmost)
* occurrence.
*
* @internal
*/
function orderSanityNodesByPosition(elements) {
	let sorted = [...elements].sort((elementA, elementB) => {
		let yDiff = elementA.rect.y - elementB.rect.y;
		return yDiff === 0 ? elementA.rect.x - elementB.rect.x : yDiff;
	}), seen = /* @__PURE__ */ new Set();
	return sorted.reduce((acc, element) => {
		let { sanity } = element;
		return !sanity || !("id" in sanity) || seen.has(sanity.id) ? acc : (seen.add(sanity.id), acc.push(sanity), acc);
	}, []);
}
/**
* Hook for reporting in use documents to Presentation
* @internal
*/
function useReportDocuments(comlink, elements, perspective, variant) {
	let $ = c(8), lastReported = useRef(void 0), t0;
	$[0] === comlink ? t0 = $[1] : (t0 = (documents, perspective_0, variant_0) => {
		comlink?.post("visual-editing/documents", {
			documents,
			perspective: perspective_0,
			variant: variant_0
		});
	}, $[0] = comlink, $[1] = t0);
	let reportDocuments = t0, t1, t2;
	$[2] !== elements || $[3] !== perspective || $[4] !== reportDocuments || $[5] !== variant ? (t1 = () => {
		let orderedNodes = orderSanityNodesByPosition(elements), orderedIds = orderedNodes.map(_temp$4), lastOrderedIds = lastReported.current?.orderedIds;
		if (!lastOrderedIds || lastOrderedIds.length !== orderedIds.length || orderedIds.some((id, index) => id !== lastOrderedIds[index]) || perspective !== lastReported.current?.perspective || variant !== lastReported.current?.variant) {
			let documentsOnPage = orderedNodes.map(_temp2$3);
			lastReported.current = {
				orderedIds,
				perspective,
				variant
			}, reportDocuments(documentsOnPage, perspective, variant);
		}
	}, t2 = [
		elements,
		perspective,
		variant,
		reportDocuments
	], $[2] = elements, $[3] = perspective, $[4] = reportDocuments, $[5] = variant, $[6] = t1, $[7] = t2) : (t1 = $[6], t2 = $[7]), useEffect(t1, t2);
}
function _temp2$3(node_0) {
	let { id: _id, type, projectId: _projectId, dataset: _dataset } = node_0;
	return _projectId && _dataset ? {
		_id,
		_type: type,
		_projectId,
		_dataset
	} : {
		_id,
		_type: type
	};
}
function _temp$4(node) {
	return node.id;
}
const Root = styled.div`
  background-color: transparent;
  direction: ltr;
  inset: 0;
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: ${({ $zIndex }) => $zIndex ?? "9999999"};
`;
function raf2(fn) {
	let r0, r1;
	return r0 = requestAnimationFrame(() => {
		r1 = requestAnimationFrame(fn);
	}), () => {
		r0 !== void 0 && cancelAnimationFrame(r0), r1 !== void 0 && cancelAnimationFrame(r1);
	};
}
const DocumentReporter = (props) => {
	let $ = c(8), { documentIds } = props, t0;
	$[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0];
	let [uniqueIds, setUniqueIds] = useState(t0), t1, t2;
	$[1] === documentIds ? (t1 = $[2], t2 = $[3]) : (t1 = () => {
		startTransition(() => setUniqueIds((prev) => {
			let next = Array.from(new Set(documentIds));
			return prev.length === next.length && prev.reduce(_temp$3, next)?.length === 0 ? prev : next;
		}));
	}, t2 = [documentIds], $[1] = documentIds, $[2] = t1, $[3] = t2), useEffect(t1, t2);
	let actor = useOptimisticActor(), t3, t4;
	return $[4] !== actor || $[5] !== uniqueIds ? (t3 = () => {
		for (let id_0 of uniqueIds) actor.send({
			type: "observe",
			documentId: getDraftId(id_0)
		}), actor.send({
			type: "observe",
			documentId: getPublishedId(id_0)
		});
		return () => {
			for (let id_1 of uniqueIds) actor.send({
				type: "unobserve",
				documentId: getDraftId(id_1)
			}), actor.send({
				type: "unobserve",
				documentId: getPublishedId(id_1)
			});
		};
	}, t4 = [actor, uniqueIds], $[4] = actor, $[5] = uniqueIds, $[6] = t3, $[7] = t4) : (t3 = $[6], t4 = $[7]), useEffect(t3, t4), null;
}, OverlaysController = (props) => {
	let $ = c(12), { comlink, dispatch, inFrame, inPopUp, onDrag, overlayEnabled, rootElement } = props, { dispatchDragEndEvent } = useDragEndEvents(), sendTelemetry = useTelemetry(), t0;
	$[0] !== comlink || $[1] !== dispatch || $[2] !== dispatchDragEndEvent || $[3] !== onDrag || $[4] !== sendTelemetry ? (t0 = (message) => {
		if (message.type === "element/click") {
			let { sanity } = message;
			comlink?.post("visual-editing/focus", sanity), sendTelemetry("Visual Editing Overlay Clicked", null);
		} else if (message.type === "overlay/activate") comlink?.post("visual-editing/toggle", { enabled: !0 });
		else if (message.type === "overlay/deactivate") comlink?.post("visual-editing/toggle", { enabled: !1 });
		else if (message.type === "overlay/dragEnd") {
			let { insertPosition, target, dragGroup, flow, preventInsertDefault } = message;
			dispatchDragEndEvent({
				insertPosition,
				target,
				dragGroup,
				flow,
				preventInsertDefault
			}), insertPosition && sendTelemetry("Visual Editing Drag Sequence Completed", null);
		} else if (message.type === "overlay/dragUpdateCursorPosition") {
			onDrag(message.x, message.y);
			return;
		} else if (message.type === "overlay/dragToggleMinimap" && message.display === !0) sendTelemetry("Visual Editing Drag Minimap Enabled", null);
		else if (message.type === "overlay/setCursor") {
			let { element, cursor } = message;
			cursor ? element.style.cursor = cursor : element.style.removeProperty("cursor");
		}
		dispatch(message);
	}, $[0] = comlink, $[1] = dispatch, $[2] = dispatchDragEndEvent, $[3] = onDrag, $[4] = sendTelemetry, $[5] = t0) : t0 = $[5];
	let controller = useController(rootElement, t0, inFrame, inPopUp), t1;
	$[6] !== controller.current || $[7] !== overlayEnabled ? (t1 = () => {
		overlayEnabled ? controller.current?.activate() : controller.current?.deactivate();
	}, $[6] = controller.current, $[7] = overlayEnabled, $[8] = t1) : t1 = $[8];
	let t2;
	return $[9] !== controller || $[10] !== overlayEnabled ? (t2 = [controller, overlayEnabled], $[9] = controller, $[10] = overlayEnabled, $[11] = t2) : t2 = $[11], useEffect(t1, t2), null;
};
/**
* @internal
*/
function Overlays(props) {
	let $ = c(78), { comlink, comlinkStatus, componentResolver: _componentResolver, inFrame, inPopUp, zIndex, onPerspectiveChange, onVariantChange } = props, prefersDark = usePrefersDark(), t0;
	$[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
		contextMenu: null,
		dragInsertPosition: null,
		dragShowMinimap: !1,
		dragShowMinimapPrompt: !1,
		dragSkeleton: null,
		elements: [],
		focusPath: "",
		isDragging: !1,
		perspective: "published",
		variant: void 0,
		wasMaybeCollapsed: !1,
		dragMinimapTransition: !1,
		dragGroupRect: null
	}, $[0] = t0) : t0 = $[0];
	let [t1, dispatch] = useReducer(overlayStateReducer, t0), { contextMenu, dragInsertPosition, dragShowMinimap, dragShowMinimapPrompt, dragSkeleton, elements, isDragging, perspective, variant, wasMaybeCollapsed, dragMinimapTransition, dragGroupRect } = t1, [rootElement, setRootElement] = useState(null), t2;
	$[1] === Symbol.for("react.memo_cache_sentinel") ? (t2 = (element) => {
		element && setRootElement(element);
	}, $[1] = t2) : t2 = $[1];
	let handleRootElementRef = t2, [overlayEnabled, setOverlayEnabled] = useState(!0), t3, t4;
	$[2] === comlink ? (t3 = $[3], t4 = $[4]) : (t3 = () => {
		let unsubs = [
			comlink?.on("presentation/focus", (data) => {
				dispatch({
					type: "presentation/focus",
					data
				});
			}),
			comlink?.on("presentation/blur", (data_0) => {
				dispatch({
					type: "presentation/blur",
					data: data_0
				});
			}),
			comlink?.on("presentation/toggle-overlay", () => {
				setOverlayEnabled(_temp2$2);
			})
		].filter(Boolean);
		return () => unsubs.forEach(_temp3$1);
	}, t4 = [comlink], $[2] = comlink, $[3] = t3, $[4] = t4), useEffect(t3, t4), usePerspectiveSync(comlink, dispatch, onPerspectiveChange, onVariantChange), useReportDocuments(comlink, elements, perspective, variant);
	let t5;
	$[5] === rootElement ? t5 = $[6] : (t5 = (x, y) => {
		rootElement && (rootElement.style.setProperty("--drag-preview-x", `${x}px`), rootElement.style.setProperty("--drag-preview-y", `${y - window.scrollY}px`));
	}, $[5] = rootElement, $[6] = t5);
	let updateDragPreviewCustomProps = t5, t6, t7;
	$[7] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
		let handleClick = _temp4, altPressed = !1, handleKeyUp = (e) => {
			isAltKey(e) && altPressed && (altPressed = !1, setOverlayEnabled(_temp5));
		}, handleKeydown = (e_0) => {
			if (isAltKey(e_0)) {
				if (e_0.ctrlKey || e_0.metaKey || e_0.shiftKey) return;
				altPressed || (altPressed = !0, setOverlayEnabled(_temp6));
			}
			isHotkey(["mod", "\\"], e_0) && setOverlayEnabled(_temp7);
		}, handleWindowBlur = () => {
			altPressed && (altPressed = !1, setOverlayEnabled(_temp8));
		};
		return window.addEventListener("click", handleClick), window.addEventListener("keydown", handleKeydown), window.addEventListener("keyup", handleKeyUp), window.addEventListener("blur", handleWindowBlur), () => {
			window.removeEventListener("click", handleClick), window.removeEventListener("keydown", handleKeydown), window.removeEventListener("keyup", handleKeyUp), window.removeEventListener("blur", handleWindowBlur);
		};
	}, t7 = [setOverlayEnabled], $[7] = t6, $[8] = t7) : (t6 = $[7], t7 = $[8]), useEffect(t6, t7);
	let [overlaysFlash, setOverlaysFlash] = useState(!1), [fadingOut, setFadingOut] = useState(!1), fadeOutTimeoutRef = useRef(void 0), t8, t9;
	$[9] === overlayEnabled ? (t8 = $[10], t9 = $[11]) : (t8 = () => {
		if (overlayEnabled) return raf2(() => {
			setOverlaysFlash(!0), raf2(() => {
				setFadingOut(!0), fadeOutTimeoutRef.current = setTimeout(() => {
					setFadingOut(!1), setOverlaysFlash(!1);
				}, 1500);
			});
		});
		fadeOutTimeoutRef.current && (clearTimeout(fadeOutTimeoutRef.current), startTransition(() => {
			setOverlaysFlash(!1), setFadingOut(!1);
		}));
	}, t9 = [overlayEnabled], $[9] = overlayEnabled, $[10] = t8, $[11] = t9), useEffect(t8, t9);
	let t10;
	$[12] === elements ? t10 = $[13] : (t10 = elements.flatMap(_temp9), $[12] = elements, $[13] = t10);
	let documentIds = t10, t11;
	$[14] === Symbol.for("react.memo_cache_sentinel") ? (t11 = () => {
		dispatch({ type: "overlay/blur" });
	}, $[14] = t11) : t11 = $[14];
	let closeContextMenu = t11, optimisticActorReady = useOptimisticActorReady(), componentResolver = optimisticActorReady ? _componentResolver : void 0, [shouldHideActions, setShouldHideActions] = useState(!1);
	!shouldHideActions && inFrame && comlinkStatus === "connected" && setShouldHideActions(!0);
	let t12;
	bb0: {
		if (isDragging) {
			let t13;
			$[15] === Symbol.for("react.memo_cache_sentinel") ? (t13 = [], $[15] = t13) : t13 = $[15], t12 = t13;
			break bb0;
		}
		let t13;
		$[16] !== comlink || $[17] !== componentResolver || $[18] !== dragMinimapTransition || $[19] !== dragShowMinimap || $[20] !== elements || $[21] !== inFrame || $[22] !== isDragging || $[23] !== optimisticActorReady || $[24] !== props.plugins || $[25] !== shouldHideActions || $[26] !== wasMaybeCollapsed ? (t13 = elements.filter(_temp0).map((t14) => {
			let { id, element: element_1, focused, hovered, rect, sanity, dragDisabled, targets, elementType } = t14, draggable = !dragDisabled && !!element_1.getAttribute("data-sanity") && optimisticActorReady && elements.some((e_2) => "id" in e_2.sanity && "id" in sanity && sanityNodesExistInSameArray(e_2.sanity, sanity) && e_2.sanity.path !== sanity.path);
			return /* @__PURE__ */ jsx(ElementOverlay, {
				comlink,
				componentResolver,
				plugins: props.plugins,
				element: element_1,
				enableScrollIntoView: !isDragging && !dragMinimapTransition && !dragShowMinimap,
				id,
				focused,
				hovered,
				node: sanity,
				rect,
				showActions: !shouldHideActions,
				draggable,
				isDragging: isDragging || dragMinimapTransition,
				wasMaybeCollapsed: focused && wasMaybeCollapsed,
				targets,
				elementType,
				inFrame
			}, id);
		}), $[16] = comlink, $[17] = componentResolver, $[18] = dragMinimapTransition, $[19] = dragShowMinimap, $[20] = elements, $[21] = inFrame, $[22] = isDragging, $[23] = optimisticActorReady, $[24] = props.plugins, $[25] = shouldHideActions, $[26] = wasMaybeCollapsed, $[27] = t13) : t13 = $[27], t12 = t13;
	}
	let elementsToRender = t12, t13 = prefersDark ? "dark" : "light", t14 = fadingOut ? "" : void 0, t15 = overlaysFlash ? "" : void 0, t16;
	$[28] !== documentIds || $[29] !== perspective ? (t16 = /* @__PURE__ */ jsx(DocumentReporter, {
		documentIds,
		perspective
	}), $[28] = documentIds, $[29] = perspective, $[30] = t16) : t16 = $[30];
	let t17;
	$[31] !== comlink || $[32] !== inFrame || $[33] !== inPopUp || $[34] !== overlayEnabled || $[35] !== rootElement || $[36] !== updateDragPreviewCustomProps ? (t17 = /* @__PURE__ */ jsx(OverlaysController, {
		comlink,
		dispatch,
		inFrame,
		inPopUp,
		onDrag: updateDragPreviewCustomProps,
		overlayEnabled,
		rootElement
	}), $[31] = comlink, $[32] = inFrame, $[33] = inPopUp, $[34] = overlayEnabled, $[35] = rootElement, $[36] = updateDragPreviewCustomProps, $[37] = t17) : t17 = $[37];
	let t18;
	$[38] === contextMenu ? t18 = $[39] : (t18 = contextMenu && /* @__PURE__ */ jsx(ContextMenu, {
		...contextMenu,
		onDismiss: closeContextMenu
	}), $[38] = contextMenu, $[39] = t18);
	let t19;
	$[40] !== dragGroupRect || $[41] !== dragInsertPosition || $[42] !== dragMinimapTransition || $[43] !== dragShowMinimapPrompt || $[44] !== isDragging ? (t19 = isDragging && !dragMinimapTransition && /* @__PURE__ */ jsxs(Fragment$1, { children: [
		dragInsertPosition && /* @__PURE__ */ jsx(OverlayDragInsertMarker, { dragInsertPosition }),
		dragShowMinimapPrompt && /* @__PURE__ */ jsx(OverlayMinimapPrompt, {}),
		dragGroupRect && /* @__PURE__ */ jsx(OverlayDragGroupRect, { dragGroupRect })
	] }), $[40] = dragGroupRect, $[41] = dragInsertPosition, $[42] = dragMinimapTransition, $[43] = dragShowMinimapPrompt, $[44] = isDragging, $[45] = t19) : t19 = $[45];
	let t20;
	$[46] !== dragSkeleton || $[47] !== isDragging ? (t20 = isDragging && dragSkeleton && /* @__PURE__ */ jsx(OverlayDragPreview, { skeleton: dragSkeleton }), $[46] = dragSkeleton, $[47] = isDragging, $[48] = t20) : t20 = $[48];
	let t21;
	$[49] !== elementsToRender || $[50] !== t14 || $[51] !== t15 || $[52] !== t16 || $[53] !== t17 || $[54] !== t18 || $[55] !== t19 || $[56] !== t20 || $[57] !== zIndex ? (t21 = /* @__PURE__ */ jsxs(Root, {
		"data-fading-out": t14,
		"data-overlays": t15,
		ref: handleRootElementRef,
		$zIndex: zIndex,
		children: [
			t16,
			t17,
			t18,
			elementsToRender,
			t19,
			t20
		]
	}), $[49] = elementsToRender, $[50] = t14, $[51] = t15, $[52] = t16, $[53] = t17, $[54] = t18, $[55] = t19, $[56] = t20, $[57] = zIndex, $[58] = t21) : t21 = $[58];
	let t22;
	$[59] !== comlink || $[60] !== t21 ? (t22 = /* @__PURE__ */ jsx(SharedStateProvider, {
		comlink,
		children: t21
	}), $[59] = comlink, $[60] = t21, $[61] = t22) : t22 = $[61];
	let t23;
	$[62] !== comlink || $[63] !== t22 ? (t23 = /* @__PURE__ */ jsx(PreviewSnapshotsProvider, {
		comlink,
		children: t22
	}), $[62] = comlink, $[63] = t22, $[64] = t23) : t23 = $[64];
	let t24;
	$[65] !== comlink || $[66] !== elements || $[67] !== t23 ? (t24 = /* @__PURE__ */ jsx(SchemaProvider, {
		comlink,
		elements,
		children: t23
	}), $[65] = comlink, $[66] = elements, $[67] = t23, $[68] = t24) : t24 = $[68];
	let t25;
	$[69] !== rootElement || $[70] !== t24 ? (t25 = /* @__PURE__ */ jsx(LayerProvider, { children: /* @__PURE__ */ jsx(PortalProvider, {
		element: rootElement,
		children: t24
	}) }), $[69] = rootElement, $[70] = t24, $[71] = t25) : t25 = $[71];
	let t26;
	$[72] !== t13 || $[73] !== t25 ? (t26 = /* @__PURE__ */ jsx(ThemeProvider, {
		scheme: t13,
		theme: studioTheme,
		tone: "transparent",
		children: t25
	}), $[72] = t13, $[73] = t25, $[74] = t26) : t26 = $[74];
	let t27;
	return $[75] !== comlink || $[76] !== t26 ? (t27 = /* @__PURE__ */ jsx(TelemetryProvider, {
		comlink,
		children: t26
	}), $[75] = comlink, $[76] = t26, $[77] = t27) : t27 = $[77], t27;
}
function _temp0(e_1) {
	return e_1.activated || e_1.focused;
}
function _temp9(element_0) {
	return "id" in element_0.sanity ? [element_0.sanity.id] : [];
}
function _temp8(enabled_3) {
	return !enabled_3;
}
function _temp7(enabled_2) {
	return !enabled_2;
}
function _temp6(enabled_1) {
	return !enabled_1;
}
function _temp5(enabled_0) {
	return !enabled_0;
}
function _temp4(event) {
	let target = event.target;
	if ((isHTMLAnchorElement(target) || isHTMLElement(target) && target.closest("a")) && event.altKey) {
		event.preventDefault(), event.stopPropagation();
		let newEvent = new MouseEvent(event.type, {
			...event,
			altKey: !1,
			bubbles: !0,
			cancelable: !0
		});
		event.target?.dispatchEvent(newEvent);
	}
}
function _temp3$1(unsub) {
	return unsub();
}
function _temp2$2(enabled) {
	return !enabled;
}
const MODIFIERS = {
	alt: "altKey",
	ctrl: "ctrlKey",
	mod: typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform) ? "metaKey" : "ctrlKey",
	shift: "shiftKey"
};
function isHotkey(keys, event) {
	return keys.every((key) => MODIFIERS[key] ? event[MODIFIERS[key]] : event.key === key.toUpperCase());
}
function isAltKey(event) {
	return event.key === "Alt";
}
function _temp$3(acc, prevId) {
	return acc.filter((id) => id !== prevId);
}
/**
* @internal
*/
const Refresh = (props) => {
	let $ = c(4), { comlink, refresh } = props, manualRefreshRef = useRef(0), mutationRefreshRef = useRef(0), t0, t1;
	return $[0] !== comlink || $[1] !== refresh ? (t0 = () => comlink.on("presentation/refresh", (data) => {
		if (data.source === "manual") {
			clearTimeout(manualRefreshRef.current);
			let promise = refresh(data);
			if (promise === !1) return;
			comlink.post("visual-editing/refreshing", data);
			let timedOut = !1;
			manualRefreshRef.current = window.setTimeout(() => {
				comlink.post("visual-editing/refreshed", data), timedOut = !0;
			}, 3e3), promise?.finally?.(() => {
				timedOut || (clearTimeout(manualRefreshRef.current), comlink.post("visual-editing/refreshed", data));
			});
		} else if (data.source === "mutation") {
			clearTimeout(mutationRefreshRef.current);
			let promise_0 = refresh(data);
			if (promise_0 === !1) return;
			comlink.post("visual-editing/refreshing", data), mutationRefreshRef.current = window.setTimeout(() => {
				let promise_1 = refresh(data);
				promise_1 !== !1 && (comlink.post("visual-editing/refreshing", data), promise_1?.finally?.(() => {
					comlink.post("visual-editing/refreshed", data);
				}) || comlink.post("visual-editing/refreshed", data));
			}, 1e3), promise_0?.finally?.(() => {
				comlink.post("visual-editing/refreshed", data);
			}) || comlink.post("visual-editing/refreshed", data);
		}
	}), t1 = [comlink, refresh], $[0] = comlink, $[1] = refresh, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1), null;
};
/**
* Hook for maintaining a channel between overlays and the presentation tool
* @internal
*/
function useComlink(t0) {
	let $ = c(9), active = t0 === void 0 || t0, [node, setNode] = useState(), [status, setStatus] = useState("idle"), t1, t2;
	$[0] === active ? (t1 = $[1], t2 = $[2]) : (t1 = () => {
		if (!active) return;
		let instance = createNode({
			name: "visual-editing",
			connectTo: "presentation"
		}, createNodeMachine().provide({ actors: createCompatibilityActors() })), unsub = instance.onStatus(() => setStatus("connected"), "connected");
		startTransition(() => setNode(instance));
		let stop = instance.start();
		return () => {
			unsub(), stop(), startTransition(() => setNode(void 0));
		};
	}, t2 = [active], $[0] = active, $[1] = t1, $[2] = t2), useEffect(t1, t2);
	let t3, t4;
	$[3] === status ? (t3 = $[4], t4 = $[5]) : (t3 = () => {
		if (status === "connected") return;
		let controller = new AbortController();
		return window.addEventListener("message", _temp$2, { signal: controller.signal }), () => {
			controller.abort();
		};
	}, t4 = [status], $[3] = status, $[4] = t3, $[5] = t4), useEffect(t3, t4);
	let t5;
	return $[6] !== node || $[7] !== status ? (t5 = [node, status], $[6] = node, $[7] = status, $[8] = t5) : t5 = $[8], t5;
}
function _temp$2(t0) {
	let { data, origin } = t0;
	data && typeof data == "object" && "domain" in data && data.domain === "sanity/channels" && "from" in data && data.from === "presentation" && "type" in data && data.type === "presentation/status" && window.parent.postMessage({
		domain: "sanity/channels",
		type: "visual-editing/status",
		data: { origin: location.origin }
	}, origin);
}
/**
* Creates a single, shared, listener EventSource that strems remote mutations, and notifies when it's online (welcome), offline (reconnect).
*/
function createSharedListener(comlink) {
	let incomingConnection$ = new ReplaySubject(1), incomingMutations$ = new Subject();
	return comlink.fetch("visual-editing/snapshot-welcome", void 0, { suppressWarnings: !0 }).then((data) => {
		incomingConnection$.next(data.event);
	}).catch(() => {}), comlink.on("presentation/snapshot-event", (data) => {
		data.event.type === "reconnect" && incomingConnection$.next(data.event), data.event.type === "mutation" && incomingMutations$.next(data.event);
	}), merge(incomingConnection$, incomingMutations$);
}
/**
* Hook for maintaining a channel between overlays and the presentation tool
* @internal
*/
function useDatasetMutator(comlink) {
	let $ = c(3), t0, t1;
	$[0] === comlink ? (t0 = $[1], t1 = $[2]) : (t0 = () => {
		if (!comlink) return;
		let listener = createSharedListener(comlink), datasetMutator = createDatasetMutator(comlink), mutator = createActor(datasetMutator, { input: {
			client: { withConfig: _temp$1 },
			sharedListener: listener
		} });
		mutator.start();
		let featuresFetch = new AbortController();
		return comlink.fetch("visual-editing/features", void 0, {
			signal: featuresFetch.signal,
			suppressWarnings: !0
		}).then((data) => {
			data.features.optimistic && setActor(mutator);
		}).catch(_temp2$1), () => {
			mutator.stop(), featuresFetch.abort();
		};
	}, t1 = [comlink], $[0] = comlink, $[1] = t0, $[2] = t1), useEffect(t0, t1);
}
function _temp2$1() {
	console.warn("[@sanity/visual-editing] Package version mismatch detected: Please update your Sanity studio to prevent potential compatibility issues.");
}
function _temp$1() {}
const LoaderComlink = lazy(() => import("./LoaderComlink-DeCFIlRj.js")), VisualEditing = (props) => {
	let $ = c(44), { components, plugins, history, keepStegaOnCopy, portal: t0, refresh, zIndex, onPerspectiveChange, onVariantChange, onSuspiciousStega } = props, portal = t0 === void 0 || t0, [inFrame, setInFrame] = useState(null), [inPopUp, setInPopUp] = useState(null), t1, t2;
	$[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
		startTransition(() => {
			setInFrame(isMaybePreviewIframe()), setInPopUp(isMaybePreviewWindow());
		});
	}, t2 = [], $[0] = t1, $[1] = t2) : (t1 = $[0], t2 = $[1]), useEffect(t1, t2);
	let t3, t4;
	$[2] === keepStegaOnCopy ? (t3 = $[3], t4 = $[4]) : (t3 = () => {
		if (!keepStegaOnCopy) return enableStegaCleanOnCopy();
	}, t4 = [keepStegaOnCopy], $[2] = keepStegaOnCopy, $[3] = t3, $[4] = t4), useEffect(t3, t4);
	let t5;
	$[5] === onSuspiciousStega ? t5 = $[6] : (t5 = (reports) => onSuspiciousStega?.(reports), $[5] = onSuspiciousStega, $[6] = t5);
	let handleSuspiciousStega = useEffectEvent(t5), hasSuspiciousStegaCallback = typeof onSuspiciousStega == "function", t6;
	$[7] !== handleSuspiciousStega || $[8] !== hasSuspiciousStegaCallback ? (t6 = () => {
		if (hasSuspiciousStegaCallback) return observeSuspiciousStega(handleSuspiciousStega);
	}, $[7] = handleSuspiciousStega, $[8] = hasSuspiciousStegaCallback, $[9] = t6) : t6 = $[9];
	let t7;
	$[10] === hasSuspiciousStegaCallback ? t7 = $[11] : (t7 = [hasSuspiciousStegaCallback], $[10] = hasSuspiciousStegaCallback, $[11] = t7), useEffect(t6, t7);
	let [portalElement, setPortalElement] = useState(null), t8, t9;
	$[12] === portal ? (t8 = $[13], t9 = $[14]) : (t8 = () => {
		if (portal === !1) return;
		let node = document.createElement("sanity-visual-editing");
		return document.documentElement.appendChild(node), startTransition(() => setPortalElement(node)), () => {
			startTransition(() => setPortalElement(null)), document.documentElement.contains(node) && document.documentElement.removeChild(node);
		};
	}, t9 = [portal], $[12] = portal, $[13] = t8, $[14] = t9), useEffect(t8, t9);
	let [comlink, comlinkStatus] = useComlink(inFrame === !0 || inPopUp === !0);
	useDatasetMutator(comlinkStatus === "connected" ? comlink : void 0);
	let hasQueryListeners = useDeferredValue(useSyncExternalStore(subscribeQueryListenerStatus, getQueryListenerStatus, _temp), !1), t10, t11;
	$[15] !== comlinkStatus || $[16] !== inFrame || $[17] !== inPopUp ? (t10 = () => {
		if (comlinkStatus === "connected") setEnvironment(inPopUp ? "presentation-window" : "presentation-iframe");
		else if (inFrame || inPopUp) {
			let timeout = setTimeout(_temp2, 1e3);
			return () => {
				clearTimeout(timeout), setEnvironment(null);
			};
		} else setEnvironment("standalone");
		return _temp3;
	}, t11 = [
		comlinkStatus,
		inPopUp,
		inFrame
	], $[15] = comlinkStatus, $[16] = inFrame, $[17] = inPopUp, $[18] = t10, $[19] = t11) : (t10 = $[18], t11 = $[19]), useEffect(t10, t11);
	let t12;
	$[20] !== comlink || $[21] !== comlinkStatus || $[22] !== components || $[23] !== inFrame || $[24] !== inPopUp || $[25] !== onPerspectiveChange || $[26] !== onVariantChange || $[27] !== plugins || $[28] !== zIndex ? (t12 = inFrame !== null && inPopUp !== null && /* @__PURE__ */ jsx(Overlays, {
		comlink,
		comlinkStatus,
		componentResolver: components,
		onPerspectiveChange,
		onVariantChange,
		plugins,
		inFrame,
		inPopUp,
		zIndex
	}), $[20] = comlink, $[21] = comlinkStatus, $[22] = components, $[23] = inFrame, $[24] = inPopUp, $[25] = onPerspectiveChange, $[26] = onVariantChange, $[27] = plugins, $[28] = zIndex, $[29] = t12) : t12 = $[29];
	let t13;
	$[30] !== comlink || $[31] !== history || $[32] !== refresh ? (t13 = comlink && /* @__PURE__ */ jsxs(Fragment$1, { children: [
		/* @__PURE__ */ jsx(History, {
			comlink,
			history
		}),
		/* @__PURE__ */ jsx(Meta, { comlink }),
		refresh && /* @__PURE__ */ jsx(Refresh, {
			comlink,
			refresh
		})
	] }), $[30] = comlink, $[31] = history, $[32] = refresh, $[33] = t13) : t13 = $[33];
	let t14;
	$[34] !== comlinkStatus || $[35] !== hasQueryListeners ? (t14 = comlinkStatus === "connected" && hasQueryListeners && /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(LoaderComlink, {}) }), $[34] = comlinkStatus, $[35] = hasQueryListeners, $[36] = t14) : t14 = $[36];
	let t15;
	$[37] !== t12 || $[38] !== t13 || $[39] !== t14 ? (t15 = /* @__PURE__ */ jsxs(Fragment$1, { children: [
		t12,
		t13,
		t14
	] }), $[37] = t12, $[38] = t13, $[39] = t14, $[40] = t15) : t15 = $[40];
	let children = t15;
	if (portal === !1 || !portalElement) return children;
	let t16;
	return $[41] !== children || $[42] !== portalElement ? (t16 = createPortal(children, portalElement), $[41] = children, $[42] = portalElement, $[43] = t16) : t16 = $[43], t16;
};
VisualEditing.displayName = "VisualEditing";
function _temp() {
	return !1;
}
function _temp2() {
	return setEnvironment("standalone");
}
function _temp3() {
	return setEnvironment(null);
}
export { comlinkPerspective as a, setLoaderClientConfig as c, setLoaderVariant as d, subscribe as f, comlinkDataset as i, setLoaderComlink as l, subscribe$1 as m, addQueryListener as n, comlinkProjectId as o, getSnapshot as p, comlink as r, comlinkVariant as s, VisualEditing as t, setLoaderPerspective as u };

//# sourceMappingURL=VisualEditing-CdJu-qkj.js.map